document.res_ru = {
	// ── PL.tip: шапка коробки строится в JS (раньше #{global.tip}) ──
	tipHeader_title: "Совет",
	// × подсказки в режиме с пояснениями (js/pl/tip.js) — только aria-label
	tipClose_label: "Закрыть",
	touchRotateHint_body: "Поверните планшет горизонтально — тогда боковая панель поместится рядом со страницей.",
	touchRotateHintClose_label: "Закрыть",
	// ── Touch layer: the tap copy (tablet-support-plan.md §7b, S7) ──
	// js/touch/copy.js reads <key>_touch in place of <key> on a touch device (seam T-16, util.js
	// getRes). Same meaning, the finger's verb; a line that offered Enter/Esc as the other way drops it.
	obTourWlAdd_body_touch: "Нажмите эту кнопку и выберите список — слово сразу попадёт в выбранный. Списки слов нужны, чтобы собрать именно те слова, которые вы хотите выучить и отрабатывать.",
	obTourMyList_body_touch: "Здесь все слова и выражения, добавленные в ваш список слов. Нажмите на него, чтобы открыть список.",
	obTourBandAdd_body_touch: "Она есть у каждого списка: переносит слова из списка в ваш набор. Нажмите её.",
	obTourBandFive_body_touch: "Нажмите маленькую стрелку рядом с 5 — и будут выбраны пять случайных слов.",
	obWlOffer_body_touch: "Теперь всё готово — нажмите «Начать изучение!» и выучите свои новые слова.\n\nНо прежде чем двигаться дальше, покажу поближе Списки слов. Там есть на что посмотреть! Тур по спискам слов можно пройти и позже — из меню {?}.\n\nПродолжить тур?",
	obWlGarden_body_touch: "Здесь растёт каждое посаженное слово, распределённое по тому, насколько хорошо оно вам знакомо. Нажмите «Мой сад», чтобы открыть.",
	obWlLevels_body_touch: "Все слова словаря разбиты на списки по уровням — от самых простых до самых трудных. Нажмите на список, чтобы открыть его и посмотреть слова.",
	obWlTopicPick_body_touch: "За одной строкой — восемнадцать списков: еда, путешествия, работа и всё остальное. Нажмите на подсвеченный, чтобы открыть его.",
	obWlTopicWord_body_touch: "Нажмите на слово в любом списке слов, чтобы увидеть его словарную статью. Попробуйте с подсвеченным.",
	obWlFilter_body_touch: "Нажмите на увеличительное стекло, чтобы быстро найти слова во всех своих списках слов.",
	obWlNew_body_touch: "Нажмите эту кнопку, чтобы создать новый список слов — собирайте в нём слова по урокам, по песням, по темам, как вам удобно.",
	obWlNewUse_body_touch: "В следующий раз, когда вы нажмёте {0} на слове, которое хотите сохранить, его можно будет отправить в этот список.",
	obMeetReveal_body_touch: "Попробуйте угадать, а затем нажмите на слово, чтобы увидеть значение.",
	obTourRowOpen_touch: "Нажмите на слово, чтобы открыть его статью, — там есть кнопка, которая отправит его на изучение.",
	obMeetEntry_body_touch: "У каждого слова, с которым вы знакомитесь, есть полная словарная статья: значения, грамматика, примеры и произношение. Перевод — сверху, остальное ниже. Нажмите и удерживайте слово или помету, чтобы увидеть, что они означают.",
	obMeetGotIt_body_touch: "Когда дочитаете, нажмите «{0}».",
	obTipExpStart_body_touch: "<p>Нажмите «Начать изучение», чтобы познакомиться с первой парой слов — для первого занятия они выбраны случайно, по вашему уровню. В дальнейшем вы сможете сами выбирать любые слова.</p><p>Обратите внимание: во время тура большая часть приложения намеренно недоступна, чтобы ничто не отвлекало от самого простого пути. После тура вам, конечно, будут доступны все функции.</p>",
	obTipExpList_body_touch: "Нажмите на этот словарный список слов, чтобы открыть его.",
	obTipExpChip_body_touch: "Нажмите на эту букву, чтобы открыть самый простой список слов в словаре.",
	obTipExpAdd_body_touch: "Эта кнопка добавляет слова из открытого списка в набор для изучения — нажмите и выберите, сколько.",
	obGuideFive_body_touch: "Нажмите маленькую стрелку — и 3 случайных слова попадут в набор для изучения.",
	obGuideFiveNext_body_touch: "Нажмите маленькую стрелку — и 5 случайных слов попадут в набор для изучения.",
	obGuideDrill_body_touch: "Нажмите «Начать упражнение!» — короткая отработка на время закрепит эти слова.",
	obTipSpacePron_body_touch: "Нажмите кнопку с динамиком, чтобы услышать, как звучит слово. Она есть везде, где слово можно послушать.",
	obTipThirsty_body_touch: "Некоторые растения хотят пить. Нажмите на плашку, чтобы добавить в набор именно эти слова и быстро их полить.",
	learnStudyTerm_tooltip_touch: "Открыть полную словарную статью этого слова",
	learnMeet_reveal_label_touch: "Знаете перевод? Нажмите здесь, чтобы увидеть",
	learnQ_pickHint_touch: "Нажмите нужную карточку",
	stopButton_tooltip_touch: "Остановить упражнение и вернуться на главную страницу",
	phraseBand_pagerRow_tooltip_touch: "Строки {0}–{1} из {2} — нажмите, чтобы перейти",
	startButton_tooltip_touch: "Нажмите, чтобы начать учить слова!",
	practiceDir_mix_tooltip_touch: "Нажмите оба направления для смешанного занятия: каждое слово пойдёт в ту сторону, в которую НЕ шло в прошлый раз<p/>(набор остаётся той же длины — одна карточка на слово)",
	pauseButton_tooltip_touch: "Нажмите, чтобы приостановить изучение слов",
	continueButton_tooltip_touch: "Нажмите, чтобы продолжить изучение слов",
	richTerm_tooltip_touch: "Нажмите, чтобы свернуть, — или кнопка «Назад» в браузере, чтобы выйти",
	revealTerm_tooltip_touch: "Нажмите, чтобы открыть словарную статью",
	pronDialPlay_hint_touch: "нажмите, чтобы прослушать",
	wlGarden_tooltip_touch: "Все слова, с которыми вы действительно работали: что нужно полить, что начато и что растёт<p/>Нажмите на цветок, чтобы увидеть весь сад",
	wlLevelSort_tooltip_touch: "Порядок в списке — нажмите, чтобы сменить",
	wlLevelCompactHint_tooltip_touch: "<p>Двойное касание: свернуть строки уровней в одну полосу.</p><p>Двойное касание 📖 на полосе — развернуть обратно.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlLevelExpandHint_tooltip_touch: "<p>Двойное касание: развернуть, по строке на уровень.</p><p>Двойное касание 📖 в строке — снова свернуть.</p><p>Касание буквы открывает этот список.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlVerbCompactHint_tooltip_touch: "<p>Двойное касание: свернуть строки глаголов в одну полосу.</p><p>Двойное касание 📝 на полосе — развернуть обратно.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlVerbExpandHint_tooltip_touch: "<p>Двойное касание: развернуть, по строке на список.</p><p>Двойное касание значка строки — снова свернуть.</p><p>Касание значка открывает этот список.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	richTopicHint_tooltip_touch: "(нажмите, чтобы открыть список слов этой темы)",
	knownToggle_tooltip_touch: "Отметить это значение как уже известное — упражнения его пропустят (нажмите ещё раз, чтобы отменить)",
	exGroup_recalled_tooltip_touch: "Эти слова вы воспроизвели на том уровне, который сами задали ползунком уровня строгости. Нажмите на слова, чтобы посмотреть или изменить, где стоит эта планка, — только она решает, в какую группу попадёт слово.",
	exGroup_notRecalled_tooltip_touch: "Эти слова не вспомнились на том уровне, который вы сами задали ползунком уровня строгости. Ничего не потеряно, и ни одно растение не становится меньше — они просто вернутся раньше. Нажмите на слова, чтобы посмотреть или изменить, где стоит эта планка.",
	garden_stats_click_hint_touch: "Нажмите для статистики этого слова",
	garden_grow_open_touch: "Нажмите, чтобы увидеть весь сад",
	garden_thirsty_tooltip_touch: "Слова, которые пора полить<p/>Нажмите, чтобы добавить их в набор для практики",
	garden_vista_click_hint_touch: "Нажмите, чтобы открыть словарную статью",
	hist_tip_word_touch: "Слово, о котором эта строка. Нажмите на строку, чтобы увидеть всю историю его изучения.",
	hist_ws_tip_word_touch: "Слово, о котором эта строка. Нажмите на строку, чтобы открыть его полную историю.",
	hist_wh_tip_when_touch: "Занятие, на котором отрабатывалось это слово, — день и время начала. Нажмите на строку, чтобы открыть это занятие.",
	hist_acc_hard_sub_touch: "самая низкая точность среди слов, показанных не менее {0} раз — нажмите на слово, чтобы увидеть его историю",
	// ── end of the tap copy ──
	tipMakeSmall_label: "Уменьшить подсказки",
	tipMakeLarge_label: "Увеличить подсказки",
	// ── Онбординг: первая сессия с сопровождением (js/onboarding.js) ──
	obWelcome_title: "Добро пожаловать!",
	obWelcomeLang_label: "Я говорю на:",
	obLevelRow_label: "Ваш уровень:",
	obWelcomeBack_tooltip: "Назад на стартовую страницу — выбрать другой язык",
	obWelcome_body: "Короткий ознакомительный тур: сначала вы познакомитесь с парой слов, а затем вкладка «Практика» поможет их по-настоящему запомнить. Всего три минуты, регистрация не требуется.",
	obLevel_label: "Какой у вас уровень?",
	obLevelA_button: "Только начинаю учить {0}",
	obLevelB_button: "Могу поддержать простой разговор",
	obLevelC_button: "Знаю неплохо, но хочу увеличить словарный запас",
	obMeet_button: "Ознакомительный тур",
	// …и вторая строка той же кнопки, пока слова загружаются
	obMeet_loading: "Подбираем первые слова…",
	obExplore_button: "Осмотрюсь самостоятельно",
	obGotIt_button: "Понятно",
	obBeatBed_title: "Посажено!",
	obBeatBed_body: "Слова теперь в вашем саду. Завтра они захотят пить — возвращайтесь и полейте их.",

	// ── Онбординг: тур после первой завершённой тренировки (js/onboarding_guide.js) ──
	obTourProgress_title: "Ваш прогресс",
	obTourProgress_body: "Эта панель ведёт статистику за всё время: сколько слов выучено, насколько точны ваши ответы, сколько вы занимались.",
	obTourBack_title: "Набор пройден",
	obTourBack_body: "Кнопка «К словам» завершает занятие и даёт выбрать, что изучать дальше.",
	obTourDict_title: "Словарь",
	obTourDict_body: "У всего, что здесь можно выучить, есть словарная статья — откройте словарь.",
	obTourLookup_title: "Поиск слова",
	// {0} = изучаемый язык, {1} = слово, которое ТОЧНО есть в словаре
	obTourLookup_body: "Наберите слово, которое хотите найти в словаре ({0}), например {1}, и нажмите Enter.",
	obTourLookupPlain_body: "Наберите слово, которое хотите найти в словаре ({0}), и нажмите Enter.",
	obTourWlAdd_title: "Добавить в список слов",
	obTourWlAdd_body: "Нажмите эту кнопку и выберите список — слово сразу попадёт в выбранный. Списки слов нужны, чтобы собрать именно те слова, которые вы хотите выучить и отрабатывать.",
	obTourMyList_title: "Ваш список",
	obTourMyList_body: "Здесь все слова и выражения, добавленные в ваш список слов. Нажмите на него, чтобы открыть список.",
	obTourRowAdd_title: "В набор для изучения",
	obTourRowAdd_body: "Эта кнопка переносит слово в ваш набор для изучения — к следующему занятию.",
	obTourBand_title: "Добавьте ещё несколько",
	obTourBand_body: "Одно слово — слишком короткое занятие: откройте выделенный список — список вашего уровня — и добавьте сразу несколько случайных слов, чтобы учить их вместе. В дальнейшем вы сможете выбирать и каждое конкретное слово по отдельности.",
	obTourBandAdd_title: "Кнопка «Добавить»",
	obTourBandAdd_body: "Она есть у каждого списка: переносит слова из списка в ваш набор. Нажмите её.",
	obTourBandRandom_title: "Пусть список выберет сам",
	obTourBandRandom_body: "Кнопка «Случайно» наберёт для вас несколько разных слов — самый быстрый способ наполнить занятие.",
	obTourBandFive_title: "Взять 5",
	obTourBandFive_body: "Нажмите маленькую стрелку рядом с 5 — и будут выбраны пять случайных слов.",
	obTourBandAppend_title: "Сохранить то, что есть",
	obTourBandAppend_body: "В вашем наборе уже есть слово. Выберите второй вариант — новые слова добавятся, а прежнее останется.",

	// ── Онбординг: глава о списках слов (предлагается после первой половины тура) ──
	obWlOffer_title: "Всё готово к учёбе",
	obWlOffer_body: "Теперь всё готово — нажмите «Начать изучение!» и выучите свои новые слова.\n\nНо прежде чем двигаться дальше, покажу поближе Списки слов. Там есть на что посмотреть! Тур по спискам слов можно пройти и позже — из меню {?}.\n\nПродолжить тур?",
	obWlOfferNo_button: "Нет, продолжу самостоятельно",
	obWlOfferYes_button: "Да, покажите Списки слов",
	obWlPanel_title: "Ваши списки слов",
	obWlPanel_body: "Эта панель — ваша библиотека: готовые списки из словаря и списки, которые вы составляете сами.",
	obWlGarden_title: "Мой сад",
	obWlGarden_body: "Здесь растёт каждое посаженное слово, распределённое по тому, насколько хорошо оно вам знакомо. Нажмите «Мой сад», чтобы открыть.",
	obWlGardenAuto_title: "Заполняется сам",
	obWlGardenAuto_body: "Слова, которые вы учите, попадают сюда автоматически — добавлять их вручную не нужно.",
	obWlLevels_title: "По частоте употребления",
	obWlLevels_body: "Все слова словаря разбиты на списки по уровням — от самых простых до самых трудных. Нажмите на список, чтобы открыть его и посмотреть слова.",
	obWlTopics_title: "По темам",
	obWlTopicPick_body: "За одной строкой — восемнадцать списков: еда, путешествия, работа и всё остальное. Нажмите на подсвеченный, чтобы открыть его.",
	obWlTopicWord_title: "Сразу к статье",
	obWlTopicWord_body: "Нажмите на слово в любом списке слов, чтобы увидеть его словарную статью. Попробуйте с подсвеченным.",
	obWlFilter_title: "Найти слово",
	obWlFilter_body: "Нажмите на увеличительное стекло, чтобы быстро найти слова во всех своих списках слов.",
	obWlFilterBox_title: "Наберите для поиска",
	obWlFilterBox_body: "Наберите несколько букв в поле поиска — поиск идёт сразу по всем спискам, а число рядом со списком показывает, сколько в нём совпадений. Нажмите на список, чтобы их увидеть. Попробуйте набрать слово, которое вы уже проходили — скорее всего, оно найдётся сразу в нескольких списках.",
	obWlMine_title: "Мой список",
	obWlMine_body: "⭐ Слово, сохранённое из словаря, попадает в выбранный вами список — «Мой список» есть здесь с самого начала, но вы сможете создавать и собственные списки.",
	obWlNew_title: "Создайте свой",
	obWlNew_body: "Нажмите эту кнопку, чтобы создать новый список слов — собирайте в нём слова по урокам, по песням, по темам, как вам удобно.",
	obWlNewName_title: "Придумайте название",
	obWlNewName_body: "Наберите название, которое вам нравится, и нажмите Enter.",
	// {0} — значок «добавить в список», внутри строки
	obWlNewUse_title: "Где он появится",
	obWlNewUse_body: "В следующий раз, когда вы нажмёте {0} на слове, которое хотите сохранить, его можно будет отправить в этот список.",
	obSignReplay_title: "Теперь ваш ход",
	obSignReplay_body: "<p>Ищите любое слово, собирайте свои списки, растите свой сад слов. А главное — набирайте слова на вкладке «Практика»: то, что вы вспомнили сами, остаётся надолго.</p><p>Захотите пройти тур ещё раз — он здесь, в этом меню.</p>",

	obTourQuit_title: "Тур ещё идёт",
	obTourQuit_body: "Пока идёт тур, остальные элементы управления спят. Завершить тур и осмотреть приложение самостоятельно? Вернуться к туру можно в любой момент из меню {?}.",
	obTourQuitYes_button: "Да, завершить тур",
	obTourQuitNo_button: "Нет, продолжить тур",
	obTourQuitRestart_button: "Начать тур заново",
	obBack_button: "Назад",
	obContinue_button: "Продолжить",
	obDoorPractice_title: "Сразу к практике?",
	obDoorPractice_body: "Перейти сразу к практике? Тур продолжится там.",
	obDoorPracticeStay_button: "Нет, остаться в изучении",
	obDoorPracticeGo_button: "Да, к практике",
	obDoorDict_title: "Открыть словарь?",
	obDoorDict_body: "Это завершит тур — вы сможете начать его заново в любой момент из меню {?}.",
	obDoorDictStay_button: "Назад",
	obDoorDictGo_button: "Открыть словарь",
	obRecommended_hint: "(Рекомендуется)",

	// ── Онбординг: тур по статье на первой карточке знакомства (js/onboarding_guide.js) ──
	obMeetReveal_title: "Ваше первое слово",
	obMeetReveal_body: "Попробуйте угадать, а затем нажмите на слово — или клавишу Enter, — чтобы увидеть значение.",
	obMeetEntry_title: "Слово целиком",
	obMeetEntry_body: "У каждого слова, с которым вы знакомитесь, есть полная словарная статья: значения, грамматика, примеры и произношение. Перевод — сверху, остальное ниже.",
	// {0} = кнопка перехода на карточке знакомства
	obMeetGotIt_title: "Дальше",
	obMeetGotIt_body: "Когда дочитаете, нажмите «{0}».",
	obMeetNext_title: "Теперь вы сами",
	obMeetNext_body: "Просто следуйте подсказкам на экране, чтобы выучить свою первую пару слов с Parlevi.",

	// ── Онбординг: подсказки-маячки (js/onboarding_tips.js) ──
	obTipExpLearn_title: "Начните здесь",
	obTipExpLearn_body: "С новыми словами знакомятся на вкладке «Изучение». Возьмите несколько из списков слов слева — и можно начинать.",
	obTipExpStart_title: "Знакомство со словами",
	obTipExpStart_body: "<p>Нажмите «Начать изучение», чтобы познакомиться с первой парой слов — для первого занятия они выбраны случайно, по вашему уровню. В дальнейшем вы сможете сами выбирать любые слова.</p><p>Обратите внимание: во время тура большая часть приложения намеренно недоступна, чтобы ничто не отвлекало от самого простого пути. После тура вам, конечно, будут доступны все функции.</p>",
	obTipExpDrill_title: "Слова готовы",
	obTipExpDrill_body: "Знакомство пройдено. Перенесите слова в «Практику» — короткое упражнение их закрепит.",
	obTipExpList_title: "Откройте список слов",
	obTipExpList_body: "Нажмите на этот словарный список слов, чтобы открыть его.",
	obTipExpChip_body: "Нажмите на эту букву, чтобы открыть самый простой список слов в словаре.",
	obTipExpAdd_title: "Добавьте пару слов",
	obTipExpAdd_body: "Эта кнопка добавляет слова из открытого списка в набор для изучения — нажмите и выберите, сколько.",
	obTipExpTray_title: "Слова уже ждут",
	obTipExpTray_body: "Выбранные слова лежат в наборе для изучения на вкладке «Изучение» — можно начать в любой момент.",

	// ── Онбординг: шаги светящегося гида в меню (js/onboarding_guide.js) ──
	obGuideRandom_title: "Пусть список выберет сам",
	obGuideRandom_body: "Кнопка «Случайно» вытянет для вас горстку самых разных слов — самый быстрый способ начать.",
	obGuideFive_title: "Начните с трёх",
	obGuideFive_body: "Нажмите маленькую стрелку — и 3 случайных слова попадут в набор для изучения.",
	obGuideFiveNext_title: "Ещё 5 слов",
	obGuideFiveNext_body: "Нажмите маленькую стрелку — и 5 случайных слов попадут в набор для изучения.",
	obGuideDrill_title: "Отработайте их",
	obGuideDrill_body: "Нажмите «Начать упражнение!» — короткая отработка на время закрепит эти слова.",
	// {0} = язык, на котором отвечают на ЭТУ карточку (в смешанной сессии он меняется от карточки к карточке).
	obGuideType_title: "Ваш ход",
	obGuideType_body: "Введите здесь перевод ({0}) и нажмите Enter.",
	obGuideTypeWord_body: "Введите здесь само слово ({0}) и нажмите Enter.",
	obTipSpacePron_title: "Послушать произношение",
	obTipSpacePron_body: "Нажмите кнопку с динамиком, чтобы услышать, как звучит слово. Она есть везде, где слово можно послушать.",
	obTipThirsty_title: "Пора поливать",
	obTipThirsty_body: "Некоторые растения хотят пить. Нажмите на плашку, чтобы добавить в набор именно эти слова и быстро их полить.",
	obTipDirection_title: "Смените направление",
	obTipDirection_body: "Отвечайте на изучаемом языке, на своём — или смешайте оба в одном занятии. Кнопка с динамиком даёт отработку на слух.",
	obTipMyGarden_title: "Здесь живёт ваш сад",
	obTipMyGarden_body: "Все посаженные слова собраны в «Моём саду» — растут, хотят пить или уже стали полностью распустившимися цветками.",
	obTipAddPill_title: "Добавьте ещё слов",
	obTipAddPill_body: "Кнопка «Добавить» переносит слова из этого списка в ваш набор. По горстке за раз — так растут лучше всего.",
	obTipDictLookup_title: "Найдите любое слово",
	obTipDictLookup_body: "Наберите любое слово на изучаемом языке — значения, примеры и грамматика уже внутри.",
	obTipGear_title: "Настройте под себя",
	obTipGear_body: "Скорость занятия, число повторов, строгость проверки — настройте практику здесь.",

	// ── Справка: «?» в полосе вкладок (js/onboarding.js, спец. §7) ──
	obHelpMenu_label: "Справка",
	obHelpMenuTip_label: "Совет дня",
	obHelpMenuAllTips_label: "Все советы",
	obHelpMenuReplay_label: "Ознакомительный тур",
	obHelpMenuWlTour_label: "Тур по спискам слов",
	obHelpMenuWelcome_label: "Экран приветствия",

	// ── Совет дня (js/tips.js, docs/project/tip-of-the-day.md) ──
	tipDay_title: "Совет дня",
	tipsAll_title: "Все советы",
	tipsClose_label: "Закрыть",
	tipsOff_toast: "Советы отключены. Включить снова: Справка ▸ Все советы.",
	tipsDaily_label: "Показывать совет каждый день",
	tipsToday_label: "Сегодня",
	tipTeaseSound_tooltip: "Прослушать эту фразу",

	// ── Режим изучения (вкладка «Изучение») ──
	learnEmpty_message: "Набор для изучения пуст.",
	quickStart_line: "Возьмите слова из Списков слов слева — или быстро выберите {0} случайных слов прямо здесь:",
	quickStart_count_tooltip: "Сколько слов добавляет каждая кнопка",
	quickStart_exhausted_tooltip: "Здесь изучены все слова — выберите свои из Списков слов слева",
	learnStartButton_label: "Начать изучение!",
	learnStartButton_tooltip: "Спокойно познакомьтесь с новыми словами — без таймера и спешки",
	learnClear_tooltip: "Очистить набор для изучения",
	learnRelearn_button: "Выучить заново",
	learnRelearn_tooltip: "Отработать эти готовые слова ещё раз — лестница начнётся заново, статус «готово» сохранится",
	learnBackToTray_label: "← назад к словам",
	learnGuided_dots: "Отработка · 6 раундов на слово",
	learnNew_badge: "новое",
	learnRow_progress_tooltip: "Уже начато — лестница продолжится с того же места",
	learnStudyTerm_tooltip: "Открыть полную словарную статью этого слова",
	learnMeet_reveal_label: "Знаете перевод? Нажмите здесь или Enter, чтобы увидеть",
	learnMeet_gotIt_label: "Понятно →",
	learnMeet_fromVerb_label: "от глагола",
	learnQ_meaning: "Что это значит?",
	learnQ_pickWord: "Выберите слово для:",
	learnQ_lookalike: "Присмотритесь — какое слово значит:",
	learnQ_whoWhen: "Кто и когда?",
	learnQ_whoWhenHint: "местоимение опущено намеренно — на лицо указывает окончание",
	learnOpt_none: "Ни одно из них",
	learnNone_taught: "Верно — этого слова здесь не было.",
	learnQ_phraseMeaning: "Что здесь значит {0}?",
	learnQ_pickPhrase: "Выберите выражение для:",
	learnQ_pickGap: "Какого слова не хватает?",
	learnQ_typeGapHint: "наберите первые {0} букв пропущенного слова — оно допишется само",
	learnQ_typeFullGapHint: "наберите только пропущенное слово — вторая ошибка в букве раскроет его",
	learnQ_start: "Как оно начинается?",
	learnQ_typeHint: "наберите первые {0} букв — слово допишется само",
	learnQ_letterHint: "подсказка: начинается на {0}",
	learnQ_letterHintSubst: "подсказка: начинается на {0} — можно набрать и «{1}»",
	learnQ_hearHint: "подсказка: послушайте — вот это слово",
	learnQ_change: "Что меняется?",
	learnQ_changeHint: "наберите часть, которая меняется в каждой форме",
	learnQ_typeFull: "Теперь наберите слово целиком",
	learnQ_typeFullHint: "наберите по памяти — вторая ошибка в букве раскроет слово",
	learnQ_repeatWord: "Повторите слово",
	learnQ_hear: "Что вы услышали?",
	learnQ_pickHint: "Нажмите нужную карточку или наберите её номер",
	learnFeedback_correct: "Верно!",
	learnFeedback_wrong: "Не совсем",
	learnFeedback_retry: "будет ещё одна попытка",
	learnMiss_settling: "Слово ещё приживается — вернёмся к нему чуть позже.",
	learnMiss_continue: "Дальше →",
	learnSpace_tooltip: "Enter",
	learnReady_toast: "{0} — можно отрабатывать",
	learnRecap_head: "Познакомились с новыми словами: {0}",
	learnRecap_met: "слов, с которыми познакомились",
	learnRecap_ready: "готовы к отработке",
	learnRecap_time: "время",
	learnRecap_bridge: "Они ждут вас в наборе для практики — отработка закрепит их окончательно.",
	learnRecap_drillNow: "Перейти к практике! →",
	learnRecap_back: "Назад к изучению",
	learnNudge_message: "Совсем новых слов здесь: {0} — сначала загляните в «Изучение», и отработка пойдёт совсем иначе.",
	learnNudge_action: "Сначала изучить",
	learnError_message: "Не удалось начать занятие",

	proceed: "Продолжить?",
	error: "Произошла ошибка, извините.\nПопробуйте перезагрузить страницу",
	stopButton_tooltip: "Остановить упражнение и вернуться на главную страницу",
	langTo_tooltip: "Выберите язык, который хотите изучать",
	langFrom_tooltip: "Выберите свой родной язык или язык, который вы знаете",
	browserTitle_main: "Учим {0} — {1}",
	enDialectUs_tooltip: "Американский английский — голос озвучки, основная транскрипция и акцент, по которому оценивается произношение",
	enDialectUk_tooltip: "Британский английский — голос озвучки, основная транскрипция и акцент, по которому оценивается произношение",
	operationCannotComplete_message: "Не удалось выполнить операцию",

	myList_create_tooltip: "Создать новый список слов",
	// ── Dictionary direction: the DE⇄EN toggle and the reverse (EN → DE) hit list ──
	// {0} = the language the typed word is expected to be in. Both directions are as-you-type: the
	// forward seek walks the German dictionary, the reverse one walks the tape of English keys
	// (design §9). Enter then focuses the one word, which is what "press Enter" used to mean here.
	lookupField_placeholder_forward: "Начните вводить слово ({0}), чтобы найти словарную статью",
	lookupField_placeholder_reverse: "Начните вводить слово ({0}), чтобы найти слова с этим значением",
	dictDir_forward_tooltip: "Поиск слова ({0}) — язык, который вы изучаете (Alt+1)",
	dictDir_reverse_tooltip: "Поиск слова ({0}) — найти слова ({1}) с этим значением (Alt+2)",
	reverse_intro_message: "Начните вводить слово ({0}), чтобы увидеть слова ({1}) с этим значением.",
	startButton_label: "Начать упражнение!",
	startButton_tooltip: "Нажмите, чтобы начать учить слова!",
	startButton_noWords_message: "Для упражнения не выбрано ни одного слова.\nОткройте список слов слева и нажмите «Добавить в набор для практики».",
	connUpdating: "Parlevi перезапускается. Подождите, пожалуйста, минуту.",
	connLost: "Связь прервалась. Ваши ответы сохранены и будут отправлены, когда она восстановится.",
	connNoNewExercise: "Parlevi перезапускается. Попробуйте ещё раз через минуту.",
	revealWord_label: "Показать слово",
	revealWord_tooltip: "Показать ответ для этого слова",
	startButton_wordsInExercise: "Слова для упражнения:",
	// ── Направление практики (пара стрелок + скоба «mix» + громкоговоритель на панели Start) ──
	// Надписи на кнопках складываются из кодов языков («EN → DE») и не переводятся; здесь —
	// формулировка задачи. {0} = язык, на котором нужно печатать.
	practiceDir_forward_tooltip: "Вы видите значение — наберите слово ({0})<p/>[нажаты оба направления = микс]",
	practiceDir_reverse_tooltip: "Вы видите слово — наберите его значение ({0})<p/>[нажаты оба направления = микс]",
	practiceDir_mix_label: "микс",
	practiceDir_mix_tooltip: "Нажмите оба направления для смешанного занятия: каждое слово пойдёт в ту сторону, в которую НЕ шло в прошлый раз<p/>(набор остаётся той же длины — одна карточка на слово)",
	practiceDir_mixOff_tooltip: "Для смешанного занятия нужна практика целыми словами (одна карточка на слово)",
	practiceDir_audio_tooltip: "Подсказка на слух: вы слышите слово, а не читаете значение<p/>Сочетается с любым направлением",
	practiceDir_locked_tooltip: "Это направление используется в идущем упражнении<p/>Остановите упражнение, чтобы его изменить",
	// Combined tray view only: distinct words vs total drillable senses ({0} = words, {1} = meanings).
	trayCount_wordsAndMeanings: "{0} слов · {1} значений",
	number_of_words_remaining: "Сколько слов осталось в текущем упражнении",
	pauseButton_label: "Пауза",
	pauseButton_tooltip: "Нажмите, чтобы приостановить изучение слов",
	continueButton_label: "Продолжить",
	continueButton_tooltip: "Нажмите, чтобы продолжить изучение слов",
	practiceAgainButton_label: "Ещё раз!",
	practiceAgainButton_tooltip: "Пройдите тот же набор ещё раз — теперь слова должны получаться с первой попытки",
	backToWordsButton_label: "К словам",
	backToWordsButton_sub: "выбрать новый набор",
	stopButton_label: "Остановить",
	stopButton_sub: "(и вернуться на главную)",
	undo_label: "Отменить",
	// The message box's only button (js/msgbox.js). English-only on purpose: getRes falls back
	// to this file, and "OK" is the value in every one of the six locales (see i18n/global*.properties).
	msgOk_button: "OK",
	clearTray_button: "Очистить",
	clearTray_tooltip: "Очистить набор для практики<p/>(«Отменить» вернёт его)",
	lastFinish_label: "Последнее занятие",
	lastFinish_tooltip: "Снова показать экран последнего завершённого занятия",
	trayCapped_message: "В набор помещается не больше {0} слов — оставлено {2} из {1}. Сначала отработайте их, потом добавьте остальные.",
	practiceEmpty_message: "Ваш набор для практики пуст.",
	noWords_message: "К сожалению, для этого выбора слов пока нет",
	dict_notReady_message: "Словарь ещё загружается — одну минуту…",
	// The flag + language code are prepended as markup, so these carry only the tail: "🇬🇧 EN" + …
	reverse_head_one: "слово · 1 совпадение",
	reverse_head_many: "слово · совпадений: {0}",
	reverse_empty_message: "Нет словарной статьи для «{0}»",
	reverse_fallback_message: "Нет словарной статьи для «{0}» — показаны результаты для",
	reverse_seeAlso_label: "см. также:",
	reverse_phrases_label: "В выражениях ({0})",
	chooseLangTo_label: "Выбрать…",
	chooseLangTo_message: "Выберите язык для изучения",
	noData_message: "Сервер не вернул данных",
	wlLabel: "Списки слов",
	wlAddPick_label: "Добавить в…",
	wlAddPickNew_label: "Новый список…",
	richTerm_tooltip: "Нажмите, чтобы свернуть, — или Esc / кнопка «Назад» в браузере, чтобы выйти",
	revealTerm_tooltip: "Нажмите, чтобы открыть словарную статью — Esc вернёт к карточке",
	richEmpty_none: "Для этого слова пока нет словарной статьи.",
	richEmpty_failed: "Не удалось загрузить словарную статью. Проверьте соединение и попробуйте снова.",
	sound_tooltip: "Звук<p/>[Горячая клавиша: пробел]",

	pronMic_tooltip: "Потренируйте произношение<p/>Откроется карточка практики — удерживайте там микрофон и говорите",
	pronHold_tooltip: "Удерживайте и говорите, отпустите, когда закончите",
	pronClose_tooltip: "Закрыть",
	pronBest_label: "лучшее",
	pronDialRecognition_label: "Понятность",
	pronDialAccent_label: "Как носитель",
	pronDialLegend_label: "внешнее кольцо = эта попытка · центр = лучшее",
	pronDialRecLast_tooltip: "Эта попытка — насколько понятно слушателю сказанное: {0}",
	pronDialRecBest_tooltip: "Ваш лучший результат по понятности здесь: {0}",
	pronDialAccLast_tooltip: "Эта попытка — насколько звучание близко к речи носителя: {0}",
	pronDialAccBest_tooltip: "Ваш лучший результат по звучанию как у носителя: {0}",
	pronDialNone_tooltip: "Здесь пока ничего не сказано",
	pronDialNoBest_tooltip: "Лучший результат пока не записан",
	pronDialPlay_hint: "нажмите, чтобы прослушать",
	pronNoRecording_message: "Записи нет — ваш голос хранится только до закрытия страницы.",
	pronHint_hold: "удерживайте, чтобы говорить — отпустите, когда закончите",
	pronHint_recording: "слушаю…",
	pronHint_scoring: "оцениваю…",
	pronSoundedLike_tip: "прозвучало как /{0}/ там, где нужно /{1}/",
	pronOmitted_tip: "это слово не услышано",
	pronDiagHeard_text: "услышано: «{0}»",
	pronDiagEarHeard_text: "слушатель, не знавший, чего ожидать, услышал: «{0}»",
	pronDiagPatient_text: "терпеливый слушатель вас здесь поймёт, обычный — с трудом",
	pronDiagMissed_text: "не прозвучало: {0}",
	pronDiagSilence_text: "в этой записи ничего не слышно",
	pronDiagSound_text: "самый слабый звук: /{0}/ в «{1}»",
	pronDiagSoundOnly_text: "самый слабый звук: /{0}/",
	pronDiagPart_text: "самая слабая часть: «{0}» в «{1}»",
	pronDiagPartOnly_text: "самая слабая часть: «{0}»",
	pronDiagWord_text: "самое слабое слово: «{0}»",
	pronExpPartial_text: "часть слова не прозвучала",
	pronExpPauses_text: "длинные паузы между словами",
	pronExpFlat_text: "интонация осталась ровной",
	pronSilent_message: "Запись получилась беззвучной. Возможно, микрофон выключен или отключён.",
	pronNoMic_message: "Этот браузер не может получить здесь доступ к микрофону.",
	pronRefusalCap_message: "Недельный запас попыток исчерпан. Он пополняется через неделю после каждой попытки.",
	pronRefusalUnavailable_message: "Для этого языка оценка произношения недоступна.",
	pronRefusalAudio_message: "В этой записи ничего не слышно.",
	pronRefusalNoWord_message: "Этого слова больше нет в словаре.",
	pronRefusalProvider_message: "Оценка в этот раз не пришла.",
	hist_wh_chart_spoken: "Произношение",
	hist_wh_tip_chart_spoken: "Каждый раз, когда это слово произносилось вслух. Точка — одна попытка, оценка по самому слабому звуку; линия — лучший результат.",
	wlLoad_error_message: "Не удаётся загрузить ваши списки слов",
	wlDelete_error_message: "Не удаётся удалить список слов",
	wlRename_tooltip: "Переименовать этот список слов",
	wlDelete_tooltip: "Удалить этот список слов",
	wlNoWords_message: "Слова не выбраны",
	wlDeleteWords_tooltip: "Удалить выбранные слова из списка",
	wlCopyWords_tooltip: "Копировать выбранные слова в другой список",
	wlCopyNoLists_message: "У вас всего один список слов — сначала создайте ещё один, а затем скопируйте в него выбранные слова",
	wlDeleteWords_error_message: "Не удаётся удалить слова из списка слов",
	wlCannotLoadWords_error_message: "Не удаётся загрузить слова этого списка",
	wlCannotDeleteWord_error_message: "Не удаётся удалить слово из списка слов",
	wlCopyWords_error_message: "Не удаётся скопировать слова в другой список слов",
	wlAddNoWordList_error_message: "Не удаётся добавить слово в список — список слов не выбран",
	wlAdd_error_message: "Не удаётся добавить слово в список слов",
	wlVerbs_label: "Формы глаголов",
	wlVerbs_tooltip: "Неправильные глаголы: отрабатываются одной карточкой на глагол — сразу все его формы",
	wlConjugation_label: "Спряжение",
	wlConjugation_tooltip: "Глаголы: отрабатываются по одной форме за раз",
	wlVerbsNoForms_message: "Для этого глагола не удалось подготовить формы",
	wlVerbsTruncated_message: "Добавлены первые {0} из {1} глаголов — остальные добавьте в следующий заход",
	wlVerbsExpand_error_message: "Не удаётся подготовить формы глагола",
	wlTypedPhrases_label: "Мои выражения",
	wlTypedPhrases_tooltip: "Выражения, которые вы набрали и которых пока нет в нашем словаре, — видны только вам. Новые попадают сюда автоматически",
	wlTypedRemove_tooltip: "Убрать отсюда — копии в ваших списках останутся",
	wlGarden_label: "Мой сад",
	wlDefault_label: "Мой список",
	wlGarden_tooltip: "Все слова, с которыми вы действительно работали: что нужно полить, что начато и что растёт<p/>Нажмите на цветок, чтобы увидеть весь сад",
	wlGardenNeedsWater_tooltip: "Давно пора полить: {0}<p/>Откройте «Мой сад», чтобы их увидеть",
	wlGardenWatered_tooltip: "Поливать сейчас нечего — весь сад в порядке",
	wlGardenDifficult_label: "Трудные слова",
	wlGardenWatering_label: "Нужен полив",
	wlGardenProgress_label: "В изучении",
	wlGardenReady_label: "Готовы к практике",
	wlGardenGrowing_label: "Растут",
	wlGardenSetAside_label: "Отложено",
	wlGardenDifficult_tooltip: "Слова, которые никак не даются, — отработайте каждое в 3 разных дня, и оно уйдёт из этого списка",
	wlGardenWatering_tooltip: "Этим словам давно пора пить — полейте их сейчас, чтобы они продолжали расти",
	wlGardenProgress_tooltip: "Эти слова вы начали в разделе «Изучение», но ещё не закончили",
	wlGardenReady_tooltip: "Эти слова уже выучены, теперь им нужна практика",
	wlGardenGrowing_tooltip: "Эти слова посажены, и срок ещё не подошёл — на значке дни до следующей практики",
	wlGardenSetAside_tooltip: "Слова, которые вы отложили, — они отдыхают здесь, сохраняя всё выученное, пока вы их не разбудите",
	wlGardenEmpty_message: "Пока пусто — выучите или отработайте слово, и оно появится в вашем саду",
	wlGardenSecEmpty_tooltip: "Сейчас в этом разделе ничего нет",
	wlGardenContinueLearn_label: "Продолжить изучение",
	wlGardenAll_disabled_tooltip: "Слишком много слов сразу (максимум {0}) — возьмите «Случайные»",
	wlGardenUseSections_note: "Каждый раздел означает своё — добавляйте из заголовка нужного раздела.",
	wlLevelA_label: "Начальный",
	wlLevelB_label: "Базовый",
	wlLevelC_label: "Средний",
	wlLevelD_label: "Продвинутый",
	wlLevelE_label: "Экспертный",
	wlLevelA_tooltip: "1 000 самых частотных слов · ≈ CEFR A1",
	wlLevelB_tooltip: "Слова 1 001–4 000 · ≈ CEFR A2",
	wlLevelC_tooltip: "Слова 4 001–12 000 · ≈ CEFR B1",
	wlLevelD_tooltip: "Слова 12 001–24 000 · ≈ CEFR B2",
	wlLevelE_tooltip: "За пределами первых 24 000 слов · ≈ CEFR C1–C2",
	// Полосы CEFR (языки с хранимыми метками — EN после перехода C2). Метки — сами коды CEFR,
	// международные для всех локалей; подсказки — официальные однострочные дескрипторы.
	wlLevelA1_label: "A1",
	wlLevelA2_label: "A2",
	wlLevelB1_label: "B1",
	wlLevelB2_label: "B2",
	wlLevelC1_label: "C1",
	wlLevelC2P_label: "C2+",
	wlLevelA1_tooltip: "Уровень CEFR A1: понимать и употреблять знакомые повседневные выражения и простейшие фразы",
	wlLevelA2_tooltip: "Уровень CEFR A2: понимать частотные выражения на повседневные темы — семья, покупки, работа, ближайшее окружение",
	wlLevelB1_tooltip: "Уровень CEFR B1: улавливать основное в ясной литературной речи и текстах на знакомые темы",
	wlLevelB2_tooltip: "Уровень CEFR B2: понимать основные идеи сложных текстов и общаться достаточно бегло",
	wlLevelC1_tooltip: "Уровень CEFR C1: понимать разнообразные сложные объёмные тексты и гибко пользоваться языком",
	wlLevelC2P_tooltip: "Уровень CEFR C2: без труда понимать практически всё услышанное и прочитанное — плюс более редкие и специальные слова за пределами шкалы CEFR",
	// Понятное название каждой полосы CEFR. Полосы схемы A–E названы словами сами по себе
	// («Базовый», «Продвинутый»), а полосы CEFR — только кодом: код международный и остаётся,
	// но тому, кто со шкалой не знаком, он не говорит ничего. Название идёт ВМЕСТЕ с кодом:
	// под кодом на кнопке быстрого набора, после кода в строке списков слов, в начале
	// подсказки свёрнутой фишки. Есть только у слотов CEFR — см. levelPlainName().
	wlLevelA1_name: "Начальный",
	wlLevelA2_name: "Базовый",
	wlLevelB1_name: "Средний",
	wlLevelB2_name: "Выше среднего",
	wlLevelC1_name: "Продвинутый",
	// «Свободное владение» — точнее, но не помещается в строку списков слов (обрезается уже на
	// «Свободное влад…»), а обрезанное название объясняет ровно столько же, сколько сам код.
	wlLevelC2P_name: "Мастерство",
	wlLevelSortAlpha_label: "По алфавиту",
	wlLevelSortFreq_label: "По частоте употребления",
	wlLevelSort_tooltip: "Порядок в списке — нажмите, чтобы сменить",
	wlLevelCompactHint_tooltip: "<p>Двойной щелчок: свернуть строки уровней в одну полосу.</p><p>Двойной щелчок по 📖 на полосе — развернуть обратно.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlLevelExpandHint_tooltip: "<p>Двойной щелчок: развернуть, по строке на уровень.</p><p>Двойной щелчок по 📖 в строке — снова свернуть.</p><p>Щелчок по букве открывает этот список.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlLevelStripCount_tooltip: "Слов в словаре для этой языковой пары",
	wlVerbCompactHint_tooltip: "<p>Двойной щелчок: свернуть строки глаголов в одну полосу.</p><p>Двойной щелчок по 📝 на полосе — развернуть обратно.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlVerbExpandHint_tooltip: "<p>Двойной щелчок: развернуть, по строке на список.</p><p>Двойной щелчок по значку строки — снова свернуть.</p><p>Щелчок по значку открывает этот список.</p><p>Также: меню аккаунта ▸ Настройки ▸ Настройки списков слов.</p>",
	wlVerbStripCount_tooltip: "Глаголов в обоих списках для этой языковой пары",
	wlTopics_label: "Темы",
	wlTopics_tooltip: "Словарь по ситуациям — выберите тему, чтобы открыть её список слов",
	wlTopicsPick_label: "Выберите тему",
	wlTopicsEmpty_message: "Для этой языковой пары тем пока нет",
	richTopicHint_tooltip: "(нажмите, чтобы открыть список слов этой темы)",
	topic_study_label: "Учёба и образование",
	topic_travel_label: "Путешествия и транспорт",
	topic_food_label: "Еда и напитки",
	topic_health_label: "Здоровье и тело",
	topic_sport_label: "Спорт",
	topic_fashion_label: "Мода и внешность",
	topic_family_label: "Семья и отношения",
	topic_work_label: "Работа и карьера",
	topic_politics_label: "Политика и общество",
	topic_home_label: "Дом и хозяйство",
	topic_money_label: "Покупки и деньги",
	topic_nature_label: "Природа, погода и окружающая среда",
	topic_animals_label: "Животные",
	topic_tech_label: "Технологии и интернет",
	topic_media_label: "СМИ и общение",
	topic_culture_label: "Культура и развлечения",
	topic_feelings_label: "Эмоции и характер",
	topic_law_label: "Право и преступность",
	wlAddPractice_button: "В набор для практики",
	wlAddLearn_button: "В набор для изучения",
	wlAddMenuHeader_label: "Добавить слова в набор для практики",
	wlAddMenuHeaderLearn_label: "Добавить слова в набор для изучения",
	wlMenuAll_label: "Все",
	wlMenuMax_label: "Макс. (первые {0})",
	wlMenuSelected_label: "Выбранные",
	wlMenuRandom_label: "Случайные",
	wlMenuCountEdit_tooltip: "Изменить количество слов",
	trayReplace_label: "Заменить в наборе «{0}»",
	trayAppend_label: "Добавить в набор «{0}»",
	trayReplace_math: "(−{0} : +{1})",
	trayAppend_math: "({0} + {1} → {2})",
	trayReplace_tooltip: "Убрать {0} уже добавленных слов и отрабатывать вместо них эти {1}",
	trayAppend_tooltip: "Оставить {0} уже добавленных слов и добавить эти {1} — всего {2}",
	trayAppendUpTo_math: "({0} + до {1})",
	trayAppendUpTo_tooltip: "Оставить {0} уже добавленных слов и добавить ещё до {1} — те, что уже в наборе, повторно добавлены не будут"
		+ " — то, что уже в лотке, второй раз не добавится",
	trayNothingNew_tooltip: "Все {0} уже в наборе — добавлять нечего",
	trayReplaceVerbs_tooltip: "Убрать всё, что уже добавлено, и вместо этого отрабатывать эти формы глаголов (каждый глагол даёт несколько карточек, поэтому их число станет известно после раскрытия)"
		+ " (каждый глагол даёт несколько карточек, их число известно только после раскрытия)",
	trayAppendVerbs_tooltip: "Оставить всё, что уже добавлено, и добавить к нему эти формы глаголов (каждый глагол даёт несколько карточек, поэтому их число станет известно после раскрытия)"
		+ " (каждый глагол даёт несколько карточек, их число известно только после раскрытия)",
	trayFull_tooltip: "В наборе уже максимум — {0} слов; замените его или сначала освободите место",
	trayDest_practice: "Практика",
	trayDest_learn: "Изучение",
	// Кнопки быстрого добавления в лоток (docs/project/tray-add-buttons.md) — «Добавить» на
	// строке словаря / карточке / всплывающей подсказке / фразе; «Переместить» — на кнопке
	// ПРОТИВОПОЛОЖНОГО лотка в самом лотке.
	trayAddLearn_tooltip: "В изучение",
	trayAddPractice_tooltip: "В практику",
	trayMoveLearn_tooltip: "Перенести в изучение",
	trayMovePractice_tooltip: "Перенести в практику",
	trayAlreadyStaged_toast: "Уже в наборе {0}",
	wlMove_label: "Перенести в…",
	wlCopy_label: "Копировать в…",
	wlSelected_label: "выбрано",
	wlEmptyList_message: "Здесь пока нет слов — добавьте их из словаря или других списков слов",
	wlNewListPlaceholder: "Название нового списка…",
	wlFilterPlaceholder: "Фильтр слов…",
	wlxGlobalFilter_placeholder: "Найти слово во всех списках…",
	wlxGlobalFilter_tooltip: "Поиск по всем спискам слов",
	wlNoMatch_message: "Нет слов, подходящих под фильтр",
	wlCheckAll_tooltip: "Выбрать все слова",
	wlGardenSecCheckAll_tooltip: "Выбрать все слова в этом разделе",
	wlWordCount_tooltip: "Количество слов в этом списке",
	wlRowPractice_tooltip: "Добавить слово в набор для практики",
	wlRowLearn_tooltip: "Добавить слово в набор для изучения",
	wlRowMoveCopy_tooltip: "Перенести или скопировать слово в другой список слов",
	wlRowRemove_tooltip: "Убрать слово из списка",
	wlRowPark_tooltip: "Отложить слово — оно перестанет появляться в практике и сохранит всё выученное, пока вы его не разбудите. Найти его можно в «Моём саду», в полосе «Отложенные» внизу",
	wlRowWake_tooltip: "Разбудить слово — оно вернётся в практику с того места, где остановилось",
	wlRowUnmarkDifficult_tooltip: "Убрать слово из «Трудных слов»",
	wlRowDifficultMarks_tooltip: "Практика в {0} из {1} дней — отрабатывайте его в течение {1} разных дней, и оно уйдёт из этого списка",
	wlRowDifficultHeld_tooltip: "Практика в течение {0} дней — три дня набраны, но на последнем занятии слово снова выделилось. Оно уйдёт после первой практики, на которой этого не произойдёт.",
	wlRowDifficultStuck_tooltip: "Практика в течение {0} дней, а слово всё ещё выделяется — возможно, его стоит выучить заново, а не отрабатывать дальше. Отложите его или продолжайте: оно уйдёт после первой практики, на которой не будет выделено.",
	wlRowParkFailed_error_message: "Не удалось отложить слово",
	trayParkNotStarted_message: "Это слово ещё не отрабатывалось, откладывать нечего — просто уберите его из набора",
	trayRemove_tooltip: "Убрать слово из набора",

	// ── Scroll pager: the scroll bars' aria-labels (js/scroll_pager.js — no tooltip: hovering
	//    one of these controls scrolls, so a popup would cover the rows it just set moving) ──
	scrollUp_tooltip: "Прокрутить вверх",
	scrollDown_tooltip: "Прокрутить вниз",

	knownToggle_tooltip: "Отметить это значение как уже известное — упражнения его пропустят (нажмите ещё раз, чтобы отменить)",
	wlSort_tooltip: "Сортировка ваших списков (списков слов, которые вы создали сами)",
	wlSortNewest_label: "Сначала новые",
	wlSortOldest_label: "Сначала старые",
	wlSortAlpha_label: "По алфавиту",
	wlSortSize_label: "По размеру",
	wlBasket_tooltip: "Недавно удалённые списки (корзина)",
	wlBasketTitle_label: "Недавно удалённые",
	wlBasketEmpty_button: "Удалить всё навсегда",
	wlBasketEmpty_message: "Корзина пуста",
	wlRestore_button: "Восстановить",
	wlRestore_tooltip: "Восстановить этот список",
	wlDeleteForever_tooltip: "Удалить навсегда — отменить будет нельзя",
	tzDetected_text: "Определён",
	settingsTimeZone_tooltip: "Определён по вашему браузеру — всё, что приложение называет «сегодня», отсчитывается по этим часам.<p>Меняйте, только если он указан неверно или если в поездке хотите остаться на домашнем календаре.",
	settingsDayStart_tooltip: "Момент, когда начинается новый день.<p>При значении по умолчанию 03:00 занятие в час ночи ещё относится к прошлому вечеру — поздняя практика не должна стоить вам серии, — а повторение после сна идёт уже следующим днём. Поставьте 00:00, чтобы день начинался ровно в полночь.",
	signupOptional_tooltip: "Регистрация необязательна.<p> Но если вы зарегистрируетесь, ваши личные списки слов и настройки сохранятся и будут доступны с любого компьютера",
	tsVerbForms_hint: "неправильный глагол — форм: {0}",
	tsWhichVerb_question: "Какой это глагол?",
	tsWhichVerb_hint: "(подойдёт любое значение глагола)",
	tsListToSound: "Послушайте — затем наберите перевод ({0})",
	tsWordNotRetrieved: "Не удалось загрузить слова",
	tsAnswerNotSet: "Не удалось подготовить ответ",
	tsYouDoneIt: "Отличная работа!",
	tsCounterIsZero: "Счётчик на нуле",
	tsWrong: "Не совсем верно",
	tsBestAttempt_label: "ваша лучшая попытка",
	//Wrong-answer tier phrases (wrong_feedback.js): tier 1 = way off ... tier 5 = almost right.
	tsWrongT1_1: "Да, слово непростое… не спешите",
	tsWrongT1_2: "Сложное — торопиться некуда",
	tsWrongT1_3: "Коварное слово — не отступайте",
	tsWrongT2_1: "Пока нет — продолжайте",
	tsWrongT2_2: "Попробуйте ещё раз",
	tsWrongT2_3: "Это слово вам поддастся",
	tsWrongT3_1: "Уже теплее",
	tsWrongT3_2: "Вы на верном пути",
	tsWrongT3_3: "Дело идёт — не останавливайтесь",
	tsWrongT4_1: "Близко!",
	tsWrongT4_2: "Почти!",
	tsWrongT4_3: "Совсем рядом!",
	tsWrongT5_1: "Ещё чуть-чуть!",
	tsWrongT5_2: "Так близко!",
	tsWrongT5_3: "О, буквально на волосок!",
	tsSound_tooltip: "Прослушать",
	tsReady_tip: "Поставьте курсор сюда и нажмите Enter, чтобы получить следующее слово упражнения",
	tsSelfKnow: "Понимаю",
	tsSelfDontKnow: "Не понимаю",
	tsSelfRight: "Ответ верный",
	tsSelfWrong: "Ответ неверный",
	// Missing entirely before 2026-08-27 — getRes() fell through to the English frame with only
	// the language name translated ("Type the correct Русский translation here").
	tsTypeTranslation_tip: "Наберите здесь правильный перевод ({0})",
	tsTypeWord_tip: "Наберите здесь правильное слово ({0})",
	tsDefinitionWasNotSet: "Не удалось получить определение слова",
	settings_tooltip: "Настройки",
	// Practice settings dialog row tips — ENGLISH verbatim until the bundle retranslation pass
	// (owner 2026-09-01: EN in all five bundles, RU included; translate all at once later).
	prefSpeed_tooltip: "Насколько быстро идёт обратный отсчёт, пока вы печатаете. На длинные ответы времени больше; 1 — не спеша, 10 — спринт.<p>Слову, в котором вы ошиблись, при следующем показе даётся дополнительное время.",
	prefAdaptiveSpeed_tooltip: "В течение занятия каждый правильный ответ делает следующий показ этого слова чуть быстрее — на {0}% за шаг, максимум {1} шагов, — а ошибка возвращает его на шаг назад. Первый показ слова всегда идёт на обычной скорости.",
	prefStrictCaps_tooltip: "Заглавные буквы важны: ответ должен точно совпадать с написанием слова. Если выключено, заглавные и строчные считаются одинаковыми.",
	prefDrillArticle_tooltip: "Существительное засчитывается только с артиклем: <i>der Kunde</i>, а не просто <i>Kunde</i>. Артикль — часть слова, значит, и часть ответа. Если выключено, вводится одно существительное.",
	prefSelfCheck_tooltip: "Когда показано слово и нужно назвать значение, вы отвечаете про себя, а не печатаете: сначала скажите, понимаете ли слово, затем посмотрите ответ и отметьте, были ли правы. Если выключено, значение нужно набирать.",
	prefGapPhrases_tooltip: "Предложение показывается без ключевого слова, и печатать нужно только это слово. Если выключено, набирается всё предложение.<p>Короткие выражения всегда печатаются целиком — в них важна точная формулировка.",
	prefStrictness_tooltip: "Сколько нужно доказательств, чтобы слово было засчитано и выросло в вашем саду. Влево: годится слово по памяти после просмотра ответа или почти точное, а занятия короче. Вправо: точный ввод до конца отсчёта, и не один раз.<p>Строка под ползунком поясняет выбранное деление.",
	prefVerbOnlyIrregular_tooltip: "В списке спряжений остаются только неправильные глаголы — те, чьи формы приходится учить по одной. Если выключено, в нём все глаголы, включая правильные.",
	prefVerbFullParadigm_tooltip: "Глагол, добавленный из списка спряжений, приходит со всей таблицей — шесть времён в шести лицах, 36 форм. Если выключено, добавляются восемь ключевых форм: настоящее <i>ich, du, er, wir</i>; перфект <i>ich, er</i>; прошедшее <i>ich, du</i>.",
	prefVerbPronounPrefill_tooltip: "На карточке спряжения местоимение уже стоит перед полем ответа, и вы печатаете только форму глагола: <i>ich</i> дано, <i>fahre</i> набираете вы. Если выключено, местоимение тоже нужно печатать.",
	prefTypedRowOff_tooltip: "Не используется в этом направлении: здесь вы отвечаете значением, а не изучаемым словом.",
	prefSelfCheckOff_tooltip: "Не используется в этом направлении: здесь вы печатаете изучаемое слово, так что проверять себя нечего.",
	ai_unknownWord_error: "«{0}» не является известным нам словом ({1}).",
	ai_disabled_error: "Поиск с помощью ИИ сейчас недоступен.",
	ai_signIn_error: "Войдите, чтобы искать новые слова сегодня.",
	audio_signIn_message: "Войдите, чтобы и дальше слышать новые слова.",
	phraseTooLong_message: "Многовато для нашего словаря — предел 8 слов и 80 символов.",
	rich_loading_message: "Ищем…",
	rich_failed_message: "Не удалось найти. Попробуйте ещё раз.",
	rich_enriching_message: "Готовим полную статью…",
	rich_enrichFailed_message: "Для этого слова пока есть только перевод.",
	// Полоса словосочетаний под строками А–Я (только прямое направление).
	phraseBand_words_label: "В словах",
	phraseBand_collocations_label: "В словосочетаниях",
	phraseBand_examples_label: "В примерах",
	phraseBand_myPhrases_label: "Из моих выражений",
	phraseBand_noEntry_message: "Нет словарной статьи для «{0}»",
	phraseBand_stripOpen_tooltip: "Показать найденное",
	phraseBand_stripClose_tooltip: "Скрыть результаты",
	phraseBand_pagerFirst_tooltip: "К первой строке",
	phraseBand_pagerPrev_tooltip: "Назад на {0} строк — удерживайте для прокрутки",
	phraseBand_pagerNext_tooltip: "Вперёд на {0} строк — удерживайте для прокрутки",
	phraseBand_pagerLast_tooltip: "К последним строкам",
	phraseBand_pagerRow_tooltip: "Строки {0}–{1} из {2} — нажмите, чтобы перейти",
	// The wrong-toggle nudge: shown INSTEAD of generating an entry, when the typed word is not a
	// word of the language being learned but is a known meaning in the learner's own language.
	dict_wrongDirection_message: "«{0}» похоже на слово ({1}).",
	dict_wrongDirection_switch: "Искать {0} → {1}",
	dict_wrongDirection_anyway: "Нет — искать: {0}",
	dict_openMatch_prefix_message: "Вы имели в виду «{0}»?",
	dict_openMatch_corrected_message: "Показано «{0}».",
	dict_openMatch_lookup_link: "Искать «{0}» вместо этого",
	reverse_phrases_shown: "Показаны первые {0} из {1}",
	stats_panel_title: "Мой прогресс",
	// ⛔ Единственная из 21 строки с названием языка, которой не годится именительный падеж:
	// «изучали в {0}» требует предложного («в неме́цком»), а lang.name.<CODE> — именительный
	// (i18n-runtime-grammar.md §4.1). Перестроено так, чтобы падеж не понадобился.
	stats_scope_tooltip: "Всё, что вы изучали ({0}). Учитывается каждое занятие, на каком бы языке ни были подсказки.",
	stats_label_mastered: "слов выучено",
	stats_label_accuracy: "точность",
	stats_label_sessions: "занятий",
	stats_label_studied: "изучено",
	stats_streak: "{0} дн. подряд",
	stats_best_streak: "рекорд {0}",
	stats_today: "Сегодня: {0} слов · {1}",
	stats_coverage: "{0} из топ-{1} слов",
	stats_seen: "встречалось слов: {0}",
	stats_learning: "{0} в изучении",
	exSummary_flawless: "без ошибок",
	exSummary_time: "время занятия",
	exSummary_speed: "обычный ответ",
	exSummary_tricky: "Сложные слова этого занятия — добавить их в список «Сложные слова»?",
	exSummary_offerDifficult_tooltip: "Добавить в «Сложные слова» в Моём саду",
	exSummary_difficultGraduated: "Больше не сложные! 🎉",
	exSummary_difficultProgress: "Хороший прогресс со сложными словами!",
	exSummary_difficultFiled: "Добавлено в «Сложные слова»:",
	exSummary_difficultFiled_shown: "— ответ показывался {0} раз",
	exSummary_difficultFiled_shownFew: "— ответ показывался {0} раза",
	phrasePick_tooltip: "Отработать в выражениях — выберите несколько живых предложений с этим словом",
	phrasePickTitle_label: "«{0}» в выражениях",
	phrasePickAdd_label: "В отработку",
	phrasePickDrop_tooltip: "Пропустить это",
	phrasePickRestore_tooltip: "Вернуть обратно",
	phrasePickNone_message: "Для «{0}» больше нет выражений — либо их пока нет в базе, либо все уже добавлены.",
	phrasePickAdded_message: "Добавлено в отработку.",
	exSummary_bridgeMastered: "всего выучено слов: {0}",
	exOutcome_recalledCold: "вспомнилось сразу",
	exOutcome_knownSlow: "знакомо — вспомнилось медленно",
	exOutcome_knownArticle: "знакомо — артикль хромает, само слово на месте",
	exOutcome_warmUp: "нужна была разминка",
	exOutcome_relearned: "потребовался показ ответа — вернётся раньше",
	exOutcome_earlyPractice: "немного полито — полный рост, когда придёт срок",
	exOutcome_practiced: "отработано — рост придёт, когда наступит срок",
	// Что именно измерила каждая из этих строк — в её собственной подсказке. Все восемь говорят о
	// ПЕРВОМ показе слова в сессии: только он и оценивается.
	exOutcome_recalledCold_tooltip: "Первый показ, верный ответ, сразу и без подсказок.",
	exOutcome_knownSlow_tooltip: "Слово вспомнилось — просто медленнее, чем это слово обычно вам даётся. Это засчитывается как знание.",
	exOutcome_knownArticle_tooltip: "Существительное вспомнилось, артикль — нет. Вопрос повторился, но само слово засчитано как вспомненное.",
	exOutcome_warmUp_tooltip: "С первой попытки не безупречно: небольшая оплошность или ответ, пришедший позже того момента, который считается мгновенным припоминанием. Это всё равно припоминание, а не промах.",
	exOutcome_relearned_tooltip: "Слово вспомнилось только после того, как был показан ответ. Следующий срок назначен раньше, чем был бы иначе.",
	exOutcome_earlyPractice_tooltip: "Вы отработали это слово раньше дня полива. Это засчитывается, но растение делает свой шаг в дату, указанную на значке, — ранняя практика её не приближает.",
	exOutcome_earlyPractice_tooltip_v2: "Вы отработали это слово раньше дня полива. Это засчитывается, но следующая отметка роста у растения — фиксированный день его собственного календаря, а не дата на значке: взять её может только успешный ответ в этот день или незадолго до него.",
	exOutcome_practiced_tooltip: "Это слово вы сегодня уже отрабатывали. Повторный проход в тот же день не считается новым повторением — следующий шаг будет при следующем поливе.",
	exSummary_grewToday: "Выросли сегодня ({0})",
	exSummary_stillGrowing: "Ещё растут ({0})",
	// Подсказки обоих заголовков. Обе несут одно и то же правило с разных сторон: растение растёт,
	// когда оценка того, сколько вы ещё будете помнить слово, переходит следующую отметку, — а не
	// потому, что ответ был верным.
	exSummary_grewToday_tooltip: "Эти слова сегодня поднялись на ступень — стрелка показывает шаг. Растение растёт, когда оценка того, сколько вы ещё будете помнить слово, проходит следующую отметку: 1, 3, 7, 14, 30, 60 или 90 дней.",
	exSummary_stillGrowing_tooltip: "Эти слова полили, но они остались на своей ступени — так бывает чаще всего. Число перед каждым словом — это следующий полив, и обычно он отодвигается дальше, даже если картинка не меняется. Растение меняется, только когда оценка проходит следующую отметку: 1, 3, 7, 14, 30, 60 или 90 дней.",
	exSummary_sessionWords: "Слова этого занятия ({0})",
	exSummary_sessionWords_tooltip: "Все слова, которые отрабатывались на этом занятии. Что выросло, а что осталось на своей ступени, будет видно чуть позже, когда занятие будет оценено.",
	// The growth bed and its plant peek. Untranslated until now, so a Russian finish screen read
	// "Today's growth" over a Russian word list — and the two-pass render made it worse, because
	// garden_bed_session is the heading EVERY finish screen now shows for its first moment.
	garden_grow_title: "Рост за сегодня",
	garden_bed_session: "Слова этого занятия",
	garden_not_planted: "Ещё не посажено",
	garden_grow_next: "следующий полив через {0}",
	// Подсказка самого счётчика дней (кружок с числом рядом с растением). {0} — всегда дни.
	garden_water_next: "Полейте это слово снова через {0} — именно об этом и говорит число. Более ранний полив растение быстрее не вырастит.",
	garden_water_today: "Срок сегодня — слово готово к поливу. Точка остаётся пустой, пока опоздание не достигнет целых суток.",
	garden_water_overdue: "Опоздание — {0}: слово хочет пить. Ничего не потеряно: растение никогда не уменьшается, оно просто вернётся раньше.",
	// P6 garden growth v2 surfaces (buckets, sprout, soft next-mark words, decision moment)
	garden_sprout_stage_name: "Росток",

	// Восемь ступеней роста (garden.js). До 01.09.2026 были зашиты в код по-английски,
	// поэтому «выросло из Rooted» — i18n-runtime-grammar.md Sec 7.
	garden_ready_stage_name: "Готово",
	garden_stage1_name: "Увидено",
	garden_stage2_name: "Узнаётся",
	garden_stage3_name: "Вспоминается",
	garden_stage4_name: "Пускает корни",
	garden_stage5_name: "Прижилось",
	garden_stage6_name: "Знакомо",
	garden_stage7_name: "Выучено",
	// The next GROWTH mark, in soft words, appended to the watering badge's tooltip. Five spans
	// since 2026-08-25 (was three): everything past a fortnight used to collapse into "further
	// out", so 30 days and 90 days read the same and "not due to grow yet" looked like a repeated
	// non-answer. Words, never digits — that is what keeps this inside R38's "soft words only".
	// garden.js's SOFT_MARK_SPANS holds the cutoffs (3 / 14 / 45 / 75 days).
	garden_nextMark_fewDays: "Следующая проверка роста: через несколько дней.",
	garden_nextMark_twoWeeks: "Следующая проверка роста: примерно через две недели.",
	garden_nextMark_month: "Следующая проверка роста: примерно через месяц.",
	garden_nextMark_twoMonths: "Следующая проверка роста: примерно через два месяца.",
	garden_nextMark_fewMonths: "Следующая проверка роста: через несколько месяцев.",
	// ── the finish screen's three word groups (docs/project/finish-screen-classification.md) ──────
	// ONE axis: the verdict at the user's own strictness notch. The four R13 buckets are still what
	// the server sends and still decide the split INSIDE "Recalled"; they stopped being group names
	// because "Will grow soon" / "Needs sooner watering" describe what the app did, which the user
	// can check and disagree with, while the group is a claim about what they remembered.
	//
	// {1} in the two verdict heads is the linked word — main.js's exStrictnessHead splits the
	// formatted string there and drops an <a> in. Keep {1} in any translation, and inflect
	// exGroup_strictnessWord to match the case the sentence puts it in.
	exGroup_firstWatering: "Первый полив ({0})",
	// The one celebratory line on this card (owner, 2026-08-25). Deliberately says nothing about
	// pass or fail: a first practice is a first meeting, so there was nothing to recall yet.
	exGroup_firstWatering_note: "Поздравляем — первый полив! Эти побеги прижились и начали расти.",
	exGroup_firstWatering_tooltip: "Когда слово отрабатывают впервые, его побег становится настоящим растением: он занимает место в расписании поливов и начинает продвигаться к первой отметке роста. Здесь ничего не оценивается: первая практика — это первое знакомство, а не проверка памяти.",
	exGroup_recalled: "Вспомнили — на вашем {1} ({0})",
	exGroup_recalled_tooltip: "Эти слова вы воспроизвели на том уровне, который сами задали ползунком уровня строгости. Нажмите на слова, чтобы посмотреть или изменить, где стоит эта планка, — только она решает, в какую группу попадёт слово.",
	exGroup_notDueYet: "Цветку ещё не время расти ({0})",
	exGroup_notDueYet_tooltip: "Эти слова вспомнились, просто их цветку пока не подошёл срок роста. Это обычное дело, а не недоработка: растение растёт, когда доходит до своей следующей отметки — 1, 3, 7, 14, 30, 60 или 90 дней, — и никогда не потому, что дан ещё один верный ответ.",
	exGroup_notRecalled: "Не вспомнили — на вашем {1} ({0})",
	exGroup_notRecalled_tooltip: "Эти слова не вспомнились на том уровне, который вы сами задали ползунком уровня строгости. Ничего не потеряно, и ни одно растение не становится меньше — они просто вернутся раньше. Нажмите на слова, чтобы посмотреть или изменить, где стоит эта планка.",
	exGroup_strictnessWord: "уровне строгости",
	exBucket_grew: "Выросли сегодня ({0})",
	exBucket_grew_tooltip: "Эти слова сегодня достигли своей следующей отметки роста — фиксированного дня в их собственном календаре. Она зарабатывается настоящей практикой в этот день или позже, а не оценкой какой-либо модели.",
	exBucket_multiStage: "поднялись сразу на несколько ступеней",
	decisionMoment_pileUp: "На этой неделе подходит срок у многих слов — больше, чем при вашем недавнем темпе. Можно уделять занятиям немного больше времени, снизить уровень строгости на одно деление или реже добавлять новые слова.",
	decisionMoment_headroom: "Нагрузка невелика по сравнению с вашим недавним темпом — есть запас, чтобы добавить больше слов, поднять уровень строгости на одно деление или просто продолжать как есть.",
	garden_day_one: "день",
	garden_day_few: "дня",
	garden_day_many: "дней",
	garden_stats_click_hint: "Нажмите для статистики этого слова",
	garden_forms_growing: "Растущих форм: {0}",
	// ⛔ Было «выросло из {0}»: предлог «из» требует родительного падежа, а названия ступеней —
	// предикативы («Прижилось», «Узнаётся»), которые не склоняются. Пока ступени были зашиты в код
	// по-английски, это не было видно: «выросло из Rooted» ломалось иначе (i18n-runtime-grammar.md
	// §4.1 — тот же класс: код подставляет голое слово в позицию, которой нужна форма).
	// Двоеточие снимает вопрос падежа — тот же приём, что и в остальных строках этого файла.
	garden_grow_from: "предыдущая ступень: {0}",
	garden_grow_open: "Нажмите, чтобы увидеть весь сад",
	garden_sr_edu: "💡 Полив дважды в день не ускоряет рост — растениям нужно время между поливами.",
	garden_thirsty_chip: "{0} хотят пить",
	garden_thirsty_tooltip: "Слова, которые пора полить<p/>Нажмите, чтобы добавить их в набор для практики",
	// Shown on EVERY press of the chip, not only when something new landed: a press that added
	// nothing (they were all staged already) used to answer with silence and read as a broken
	// button. The sentence is true either way, and it answers the question the press was asking.
	garden_thirstyStaged_toast: "Все растения, которые хотят пить, уже в наборе — можно поливать!",
	garden_vista_title: "Мой сад",
	garden_vista_count: "Посажено слов: {0}",
	garden_vista_empty: "Пока ничего не посажено — отработайте слово, и здесь появится первый побег.",
	garden_vista_click_hint: "Нажмите, чтобы открыть словарную статью",
	garden_open_btn: "Мой сад",
	garden_open_tooltip: "Весь ваш сад слов — каждое посаженное слово на своей ступени",
	// ── «Как растёт мой сад?» — единственная справочная панель сада ──
	garden_guide_title: "Как растёт мой сад?",
	garden_guide_open_chip: "Как растёт мой сад?",
	garden_guide_ladder_note: "Отсчёт с первой практики, при условии что каждый полив вовремя.",
	// Подпись к первой ступеньке лестницы: «Ready» — это отсутствие растения, а не растение.
	// Теми же словами, что и полоса «Готовы к практике» в списках слов (wlGardenReady_tooltip).
	garden_guide_ready_note: "Первая ступень, «Готово», — это слово, которое вы уже выучили, но ещё не отрабатывали: побег уже виден, однако ничего не запланировано и отсчёт не начнётся до первого полива.",
	garden_guide_lead: "Если хорошо за ним ухаживать — около полугода. Быстрее всего — примерно за четыре месяца.",
	garden_guide_lead_v2: "Если хорошо за ним ухаживать — обычно семь-девять месяцев. Быстрее всего, поливая точно в срок на каждом шаге, — около семи месяцев.",
	garden_guide_how: "Растение поднимается на ступень каждый раз, когда вы поливаете его <em>тогда, когда оно просит</em>, и слово всё ещё помните. Перерывы между поливами сначала совсем короткие и растягиваются по мере того, как слово укореняется: день, несколько дней, неделя, две недели, месяц, два месяца. Светящийся ореол — последняя ступень, и означает он одно: слово пережило пару месяцев само по себе, а вы его всё равно знали. В сумме эти перерывы дают около четырёх месяцев даже для слова, которое даётся без труда, и около шести — для обычного. Упрямому слову нужно столько времени, сколько нужно; приложение будет работать над ним вместе с вами.",
	garden_guide_how_v2: "Растение поднимается на ступень только тогда, когда наступает срок его собственной отметки роста, — <em>а не просто потому, что вы его полили</em>. Память крепнет примерно удваивающимися шагами: если слово удаётся вспомнить после более долгого перерыва, следующий перерыв можно спокойно сделать вдвое длиннее, поэтому отметки идут так: день, три дня, неделя, две недели, месяц, два месяца, квартал. Удачный ответ незадолго до отметки тоже её засчитывает — окно короткое, но оно есть. Светящийся ореол — последняя ступень, и означает он одно: слово пережило целый квартал само по себе, а вы его всё равно знали. В сумме эти отметки дают около семи месяцев даже для слова, которое проходит каждую точно в срок, и семь-девять — для обычного: пропущенная отметка просто ждёт вашего следующего удачного ответа и ничего слову не стоит. Упрямому слову нужно столько времени, сколько нужно; приложение будет работать над ним вместе с вами.",
	garden_guide_twoThings: "Два момента, которые стоит знать:",
	garden_guide_hurryHead: "Частыми поливами дело не ускорить.",
	garden_guide_hurryBody: "Если отработать слово сегодня десять лишних раз, ничего не вырастет — приложение и так знает, что <em>сегодня</em> вы его помните. Ему важно другое: вспомните ли вы его через неделю и через месяц. Память растёт в промежутках, и растение честно это показывает.",
	garden_guide_forgetHead: "Забыть — не катастрофа.",
	garden_guide_forgetBody: "Если слово забылось, растение не уменьшается — оно просто хочет пить 💧, возвращается раньше, и вы продолжаете с того места, где остановились.",
	garden_guide_closing: "Итак: посадите слово, поливайте его, когда оно просит, и ждите ореол примерно через сезон-другой. Поторопить это нельзя — именно поэтому оно чего-то стоит. Светящийся цветок — не значок за нажатие кнопок; это приложение говорит вам: <em>теперь это слово ваше, навсегда.</em>",
	garden_guide_closing_v2: "Итак: посадите слово, поливайте его, когда оно просит, и ждите ореол через два-три сезона. Поторопить это нельзя — именно поэтому оно чего-то стоит. Светящийся цветок — не значок за нажатие кнопок; это приложение говорит вам: <em>теперь это слово ваше, навсегда.</em>",
	garden_firstplant_card: "Первое слово дало росток 🌱 — посмотрите, как оно вырастет в сияющий цветок.",
	// Транслитерированные термины — так их называет любой российский учебник немецкого
	// (владелец, 2026-08-28); описательное русское название и немецкий оригинал — в подсказке.
	// «плюскв» — принятое сокращение (лат. plusquamperf.); полное слово не влезает в чип.
	conj_tense_present: "Настоящее",
	conj_tense_past: "Прошедшее (претерит)",
	conj_tense_perfect: "Перфект",
	conj_tense_past_perfect: "Предпрошедшее",
	conj_tense_future: "Будущее",
	conj_tense_conditional: "Условное (бы)",
	conj_tense_present_tip: "Präsens / настоящее время",
	conj_tense_past_tip: "Präteritum / простое прошедшее",
	conj_tense_perfect_tip: "Perfekt / сложное прошедшее",
	conj_tense_past_perfect_tip: "Plusquamperfekt / предпрошедшее",
	conj_tense_future_tip: "Futur / будущее время",
	conj_tense_conditional_tip: "Konjunktiv II / условное наклонение (бы)",
	// ── The Spanish conjugation panel (F2a, 2026-09-08) ──────────────────────────────────
	// The nine stored TAMs of register §2.5 plus the RENDERED negative imperative, which is
	// no + the present subjunctive and is never stored. The panel heads its columns with the
	// SPANISH name (Util.paradigmPack.ES in main.js), exactly as the German table heads its
	// own with Präsens; these are the learner-language names — the chip on a card, and the
	// header's hover tip.
	conj_tense_es_pres_ind: "Настоящее",
	conj_tense_es_pret_ind: "Простое прошедшее",
	conj_tense_es_imp_aff: "Повелительное",
	conj_tense_es_imp_neg: "Отрицательное повелительное",
	conj_tense_es_imperf_ind: "Имперфект",
	conj_tense_es_fut_ind: "Будущее",
	conj_tense_es_cond: "Условное",
	conj_tense_es_pres_subj: "Настоящее сослагательное",
	conj_tense_es_imperf_subj_ra: "Прошедшее сослагательное (-ra)",
	conj_tense_es_imperf_subj_se: "Прошедшее сослагательное (-se)",
	conj_tense_es_pres_ind_tip: "presente / настоящее время",
	conj_tense_es_pret_ind_tip: "pretérito indefinido / завершённое прошедшее",
	conj_tense_es_imp_aff_tip: "imperativo / повелительное наклонение",
	conj_tense_es_imp_neg_tip: "imperativo negativo / no + презенс сослагательного",
	conj_tense_es_imperf_ind_tip: "pretérito imperfecto / длительное или привычное прошедшее",
	conj_tense_es_fut_ind_tip: "futuro simple / будущее время",
	conj_tense_es_cond_tip: "condicional / условное наклонение (бы)",
	conj_tense_es_pres_subj_tip: "presente de subjuntivo / сослагательное наклонение, настоящее",
	conj_tense_es_imperf_subj_ra_tip: "imperfecto de subjuntivo / сослагательное прошедшее, основная форма",
	conj_tense_es_imperf_subj_se_tip: "imperfecto de subjuntivo / сослагательное прошедшее, вариант на -se",
	// ── The Spanish FORM KINDS (F2b, 2026-09-08) ─────────────────────────────────────────
	// 77 kinds — 49 simple finite cells, 6 affirmative imperatives, 4 non-finite, 4 nominal,
	// 6 adjectival, 1 derived, 7 determiner/numeral — reached through PosLabel.CANON, exactly
	// like the German block above. ⭐ The _label is the SAME compact code in every bundle: a
	// finite cell names a tense AND a person, which no language abbreviates in five characters,
	// so the chip is Spanish-derived (pr2pl, ra3sg, ip1pl) and the _tooltip is the learner's.
	// Written by analytics/i18n/add_es_form_kind_keys.py — the tense halves are asserted equal
	// to the panel's own conj_tense_es_* values, so one screen never names a tense two ways.
	posVerbPresInd1Sg_label: "pr1sg",
	posVerbPresInd1Sg_tooltip: "Настоящее, 1-е лицо ед. ч. (yo)",
	posVerbPresInd2SgTu_label: "pr2sg",
	posVerbPresInd2SgTu_tooltip: "Настоящее, 2-е лицо ед. ч. (tú)",
	posVerbPresInd2SgVos_label: "prvos",
	posVerbPresInd2SgVos_tooltip: "Настоящее, 2-е лицо ед. ч., восео (vos)",
	posVerbPresInd3Sg_label: "pr3sg",
	posVerbPresInd3Sg_tooltip: "Настоящее, 3-е лицо ед. ч. (él, ella, usted)",
	posVerbPresInd1Pl_label: "pr1pl",
	posVerbPresInd1Pl_tooltip: "Настоящее, 1-е лицо мн. ч. (nosotros)",
	posVerbPresInd2PlVosotros_label: "pr2pl",
	posVerbPresInd2PlVosotros_tooltip: "Настоящее, 2-е лицо мн. ч., Испания (vosotros)",
	posVerbPresInd3Pl_label: "pr3pl",
	posVerbPresInd3Pl_tooltip: "Настоящее, 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbPretInd1Sg_label: "pt1sg",
	posVerbPretInd1Sg_tooltip: "Простое прошедшее, 1-е лицо ед. ч. (yo)",
	posVerbPretInd2SgTu_label: "pt2sg",
	posVerbPretInd2SgTu_tooltip: "Простое прошедшее, 2-е лицо ед. ч. (tú)",
	posVerbPretInd3Sg_label: "pt3sg",
	posVerbPretInd3Sg_tooltip: "Простое прошедшее, 3-е лицо ед. ч. (él, ella, usted)",
	posVerbPretInd1Pl_label: "pt1pl",
	posVerbPretInd1Pl_tooltip: "Простое прошедшее, 1-е лицо мн. ч. (nosotros)",
	posVerbPretInd2PlVosotros_label: "pt2pl",
	posVerbPretInd2PlVosotros_tooltip: "Простое прошедшее, 2-е лицо мн. ч., Испания (vosotros)",
	posVerbPretInd3Pl_label: "pt3pl",
	posVerbPretInd3Pl_tooltip: "Простое прошедшее, 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbImperfInd1Sg_label: "im1sg",
	posVerbImperfInd1Sg_tooltip: "Имперфект, 1-е лицо ед. ч. (yo)",
	posVerbImperfInd2SgTu_label: "im2sg",
	posVerbImperfInd2SgTu_tooltip: "Имперфект, 2-е лицо ед. ч. (tú)",
	posVerbImperfInd3Sg_label: "im3sg",
	posVerbImperfInd3Sg_tooltip: "Имперфект, 3-е лицо ед. ч. (él, ella, usted)",
	posVerbImperfInd1Pl_label: "im1pl",
	posVerbImperfInd1Pl_tooltip: "Имперфект, 1-е лицо мн. ч. (nosotros)",
	posVerbImperfInd2PlVosotros_label: "im2pl",
	posVerbImperfInd2PlVosotros_tooltip: "Имперфект, 2-е лицо мн. ч., Испания (vosotros)",
	posVerbImperfInd3Pl_label: "im3pl",
	posVerbImperfInd3Pl_tooltip: "Имперфект, 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbFutInd1Sg_label: "fu1sg",
	posVerbFutInd1Sg_tooltip: "Будущее, 1-е лицо ед. ч. (yo)",
	posVerbFutInd2SgTu_label: "fu2sg",
	posVerbFutInd2SgTu_tooltip: "Будущее, 2-е лицо ед. ч. (tú)",
	posVerbFutInd3Sg_label: "fu3sg",
	posVerbFutInd3Sg_tooltip: "Будущее, 3-е лицо ед. ч. (él, ella, usted)",
	posVerbFutInd1Pl_label: "fu1pl",
	posVerbFutInd1Pl_tooltip: "Будущее, 1-е лицо мн. ч. (nosotros)",
	posVerbFutInd2PlVosotros_label: "fu2pl",
	posVerbFutInd2PlVosotros_tooltip: "Будущее, 2-е лицо мн. ч., Испания (vosotros)",
	posVerbFutInd3Pl_label: "fu3pl",
	posVerbFutInd3Pl_tooltip: "Будущее, 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbCond1Sg_label: "co1sg",
	posVerbCond1Sg_tooltip: "Условное, 1-е лицо ед. ч. (yo)",
	posVerbCond2SgTu_label: "co2sg",
	posVerbCond2SgTu_tooltip: "Условное, 2-е лицо ед. ч. (tú)",
	posVerbCond3Sg_label: "co3sg",
	posVerbCond3Sg_tooltip: "Условное, 3-е лицо ед. ч. (él, ella, usted)",
	posVerbCond1Pl_label: "co1pl",
	posVerbCond1Pl_tooltip: "Условное, 1-е лицо мн. ч. (nosotros)",
	posVerbCond2PlVosotros_label: "co2pl",
	posVerbCond2PlVosotros_tooltip: "Условное, 2-е лицо мн. ч., Испания (vosotros)",
	posVerbCond3Pl_label: "co3pl",
	posVerbCond3Pl_tooltip: "Условное, 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbPresSubj1Sg_label: "sb1sg",
	posVerbPresSubj1Sg_tooltip: "Настоящее сослагательное, 1-е лицо ед. ч. (yo)",
	posVerbPresSubj2SgTu_label: "sb2sg",
	posVerbPresSubj2SgTu_tooltip: "Настоящее сослагательное, 2-е лицо ед. ч. (tú)",
	posVerbPresSubj3Sg_label: "sb3sg",
	posVerbPresSubj3Sg_tooltip: "Настоящее сослагательное, 3-е лицо ед. ч. (él, ella, usted)",
	posVerbPresSubj1Pl_label: "sb1pl",
	posVerbPresSubj1Pl_tooltip: "Настоящее сослагательное, 1-е лицо мн. ч. (nosotros)",
	posVerbPresSubj2PlVosotros_label: "sb2pl",
	posVerbPresSubj2PlVosotros_tooltip: "Настоящее сослагательное, 2-е лицо мн. ч., Испания (vosotros)",
	posVerbPresSubj3Pl_label: "sb3pl",
	posVerbPresSubj3Pl_tooltip: "Настоящее сослагательное, 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbImperfSubjRa1Sg_label: "ra1sg",
	posVerbImperfSubjRa1Sg_tooltip: "Прошедшее сослагательное (-ra), 1-е лицо ед. ч. (yo)",
	posVerbImperfSubjRa2SgTu_label: "ra2sg",
	posVerbImperfSubjRa2SgTu_tooltip: "Прошедшее сослагательное (-ra), 2-е лицо ед. ч. (tú)",
	posVerbImperfSubjRa3Sg_label: "ra3sg",
	posVerbImperfSubjRa3Sg_tooltip: "Прошедшее сослагательное (-ra), 3-е лицо ед. ч. (él, ella, usted)",
	posVerbImperfSubjRa1Pl_label: "ra1pl",
	posVerbImperfSubjRa1Pl_tooltip: "Прошедшее сослагательное (-ra), 1-е лицо мн. ч. (nosotros)",
	posVerbImperfSubjRa2PlVosotros_label: "ra2pl",
	posVerbImperfSubjRa2PlVosotros_tooltip: "Прошедшее сослагательное (-ra), 2-е лицо мн. ч., Испания (vosotros)",
	posVerbImperfSubjRa3Pl_label: "ra3pl",
	posVerbImperfSubjRa3Pl_tooltip: "Прошедшее сослагательное (-ra), 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posVerbImperfSubjSe1Sg_label: "se1sg",
	posVerbImperfSubjSe1Sg_tooltip: "Прошедшее сослагательное (-se), 1-е лицо ед. ч. (yo)",
	posVerbImperfSubjSe2SgTu_label: "se2sg",
	posVerbImperfSubjSe2SgTu_tooltip: "Прошедшее сослагательное (-se), 2-е лицо ед. ч. (tú)",
	posVerbImperfSubjSe3Sg_label: "se3sg",
	posVerbImperfSubjSe3Sg_tooltip: "Прошедшее сослагательное (-se), 3-е лицо ед. ч. (él, ella, usted)",
	posVerbImperfSubjSe1Pl_label: "se1pl",
	posVerbImperfSubjSe1Pl_tooltip: "Прошедшее сослагательное (-se), 1-е лицо мн. ч. (nosotros)",
	posVerbImperfSubjSe2PlVosotros_label: "se2pl",
	posVerbImperfSubjSe2PlVosotros_tooltip: "Прошедшее сослагательное (-se), 2-е лицо мн. ч., Испания (vosotros)",
	posVerbImperfSubjSe3Pl_label: "se3pl",
	posVerbImperfSubjSe3Pl_tooltip: "Прошедшее сослагательное (-se), 3-е лицо мн. ч. (ellos, ellas, ustedes)",
	posImpAff2SgTu_label: "ip2sg",
	posImpAff2SgTu_tooltip: "Повелительное, 2-е лицо ед. ч. (tú)",
	posImpAff2SgVos_label: "ipvos",
	posImpAff2SgVos_tooltip: "Повелительное, 2-е лицо ед. ч., восео (vos)",
	posImpAff3SgUsted_label: "ip3sg",
	posImpAff3SgUsted_tooltip: "Повелительное, 3-е лицо ед. ч. (usted)",
	posImpAff1Pl_label: "ip1pl",
	posImpAff1Pl_tooltip: "Повелительное, 1-е лицо мн. ч. (nosotros)",
	posImpAff2PlVosotros_label: "ip2pl",
	posImpAff2PlVosotros_tooltip: "Повелительное, 2-е лицо мн. ч., Испания (vosotros)",
	posImpAff3PlUstedes_label: "ip3pl",
	posImpAff3PlUstedes_tooltip: "Повелительное, 3-е лицо мн. ч. (ustedes)",
	posInfinitive_label: "inf",
	posInfinitive_tooltip: "инфинитив",
	posGerund_label: "ger",
	posGerund_tooltip: "герундий (-ando / -iendo)",
	posParticiple_label: "part",
	posParticiple_tooltip: "причастие прошедшего времени",
	posParticipleAlt_label: "part2",
	posParticipleAlt_tooltip: "причастие прошедшего времени, вторая форма",
	posNounPlural_label: "pl",
	posNounPlural_tooltip: "множественное число",
	posNounFeminineSg_label: "fsg",
	posNounFeminineSg_tooltip: "женский род, ед. ч., существительное",
	posNounFemininePl_label: "fpl",
	posNounFemininePl_tooltip: "женский род, мн. ч., существительное",
	posNounMascPlOfFemHead_label: "mpl",
	posNounMascPlOfFemHead_tooltip: "мужской род мн. ч. от заголовка женского рода",
	posAdjFemSg_label: "fsg",
	posAdjFemSg_tooltip: "женский род, ед. ч., прилагательное",
	posAdjMascPl_label: "mpl",
	posAdjMascPl_tooltip: "мужской род, мн. ч., прилагательное",
	posAdjFemPl_label: "fpl",
	posAdjFemPl_tooltip: "женский род, мн. ч., прилагательное",
	posAdjApocope_label: "apoc",
	posAdjApocope_tooltip: "усечённая форма перед существительным (gran, buen)",
	posAdjSuperlativoAbsoluto_label: "sup",
	posAdjSuperlativoAbsoluto_tooltip: "абсолютная превосходная степень (-ísimo)",
	posAdjSuperlativoAbsolutoAlt_label: "sup2",
	posAdjSuperlativoAbsolutoAlt_tooltip: "абсолютная превосходная степень, вторая форма",
	posAdvMente_label: "adv",
	posAdvMente_tooltip: "наречие на -mente",
	posDetFemSg_label: "fsg",
	posDetFemSg_tooltip: "женский род, ед. ч., детерминатив",
	posDetMascPl_label: "mpl",
	posDetMascPl_tooltip: "мужской род, мн. ч., детерминатив",
	posDetFemPl_label: "fpl",
	posDetFemPl_tooltip: "женский род, мн. ч., детерминатив",
	posDetNeuter_label: "neut",
	posDetNeuter_tooltip: "форма среднего рода (lo, esto)",
	posDetApocope_label: "apoc",
	posDetApocope_tooltip: "усечённая форма перед существительным",
	posNumFeminine_label: "fem",
	posNumFeminine_tooltip: "числительное женского рода (una, doscientas)",
	posNumApocope_label: "napo",
	posNumApocope_tooltip: "усечённое числительное (un, cien)",
	conj_person_firstSg: "1-е л. ед. ч.",
	conj_person_secondSg: "2-е л. ед. ч.",
	conj_person_thirdSg: "3-е л. ед. ч.",
	conj_person_firstPl: "1-е л. мн. ч.",
	conj_person_secondPl: "2-е л. мн. ч.",
	conj_person_thirdPl: "3-е л. мн. ч.",
	rich_perfect_tooltip: "Перфект — как этот глагол образует перфект: «hat …» с haben, «ist …» с sein",

	// ── Правило F7: испанский класс неправильности (F2b, план §4b строка 8) ───────────────────
	// На каждый класс — `_label` (чередование, показывается чипом) и `_note` (одна строка,
	// которая его объясняет). Глагол-пример во всех языках остаётся испанским: это изучаемый язык.
	verb_class_tooltip: 'Класс неправильности — как меняется основа этого глагола. Подсвеченные клетки настоящего времени — те, что меняются; остальные идут по обычному образцу.',
	verbClassOrtografico_label: 'только написание',
	verbClassOrtografico_note: 'Написание меняется, чтобы не менялось звучание: coger → cojo.',
	verbClassEIe_label: 'e → ie',
	verbClassEIe_note: 'Гласная основы под ударением превращается в дифтонг: tener → tiene.',
	verbClassOUe_label: 'o → ue',
	verbClassOUe_note: 'Гласная основы под ударением превращается в дифтонг: llover → llueve.',
	verbClassEI_label: 'e → i',
	verbClassEI_note: 'Гласная основы под ударением закрывается: pedir → pide.',
	verbClassEIeI_label: 'e → ie / i',
	verbClassEIeI_note: 'Под ударением дифтонг, без ударения закрытая гласная: sentir → siente, sintió.',
	verbClassOUeU_label: 'o → ue / u',
	verbClassOUeU_note: 'Под ударением дифтонг, без ударения закрытая гласная: dormir → duerme, durmió.',
	verbClassZco_label: '-zco',
	verbClassZco_note: 'Первое лицо единственного числа оканчивается на -zco, и за ним идёт весь субхунтив: conocer → conozco.',
	verbClassIAcento_label: 'i → í',
	verbClassIAcento_note: 'Слабая гласная под ударением получает знак и сохраняет свой слог: ampliar → amplío.',
	verbClassUAcento_label: 'u → ú',
	verbClassUAcento_note: 'Слабая гласная под ударением получает знак и сохраняет свой слог: actuar → actúo.',
	verbClassEAcento_label: 'e → í',
	verbClassEAcento_note: 'Гласная e основы под ударением пишется как í: reír → río.',
	verbClassIIe_label: 'i → ie',
	verbClassIIe_note: 'Гласная основы под ударением превращается в дифтонг: adquirir → adquiere.',
	verbClassEYe_label: 'e → ye',
	verbClassEYe_note: 'В начале слова дифтонг пишется как ye: errar → yerro.',
	verbClassUUe_label: 'u → ue',
	verbClassUUe_note: 'Гласная основы под ударением превращается в дифтонг: jugar → juega.',
	verbClassOHue_label: 'o → hue',
	verbClassOHue_note: 'В начале слова дифтонг пишется как hue: oler → huele.',
	// ── SPANISH SENSE FIELDS (S4, 2026-09-08) ───────────────────────────────────────────
	// The copula and position splits, the sense's variety limits, and the shape of a
	// government frame. Region labels are looked up FROM THE CODE — never a prose prefix in
	// a gloss (register clause 14) and never a preposition in a template (a region reads as
	// `label: A, B`, because `en Espagne` / `au Mexique` cannot both come out of one hole).
	senseCopulaSer_label: 'с ser',
	senseCopulaEstar_label: 'с estar',
	senseCopulaAmbos_label: 'ser или estar',
	sensePositionPrenominal_label: 'перед существительным',
	sensePositionPostnominal_label: 'после существительного',
	sensePositionEither_label: 'любая позиция',
	senseRegionTypeOnlyIn_label: 'только',
	senseRegionTypeNotIn_label: 'не употребляется',
	senseRegionTypePreferredIn_label: 'предпочтительно',
	senseRegionES_label: 'Испания',
	senseRegionMX_label: 'Мексика',
	senseRegionAR_label: 'Аргентина',
	senseRegionUY_label: 'Уругвай',
	senseRegionPY_label: 'Парагвай',
	senseRegionCL_label: 'Чили',
	senseRegionPE_label: 'Перу',
	senseRegionBO_label: 'Боливия',
	senseRegionEC_label: 'Эквадор',
	senseRegionCO_label: 'Колумбия',
	senseRegionVE_label: 'Венесуэла',
	senseRegionCR_label: 'Коста-Рика',
	senseRegionGT_label: 'Гватемала',
	senseRegionHN_label: 'Гондурас',
	senseRegionNI_label: 'Никарагуа',
	senseRegionPA_label: 'Панама',
	senseRegionSV_label: 'Сальвадор',
	senseRegionCU_label: 'Куба',
	senseRegionDO_label: 'Доминиканская Республика',
	senseRegionPR_label: 'Пуэрто-Рико',
	senseRegionGQ_label: 'Экваториальная Гвинея',
	senseRegionUS_label: 'США',
	senseRegionAM_label: 'Америка',
	senseRegionRPL_label: 'Ла-Плата',
	senseRegionCAM_label: 'Центральная Америка',
	senseRegionAND_label: 'Андский регион',
	senseRegionCAR_label: 'Карибы',
	senseRegionCAN_label: 'Канарские острова',
	senseConstructionPrepNp_label: '+ существительное',
	senseConstructionPrepInf_label: '+ инфинитив',
	senseConstructionPrepQueInd_label: '+ que + изъявительное',
	senseConstructionPrepQueSubj_label: '+ que + сослагательное',
	senseConstructionQueInd_label: 'que + изъявительное',
	senseConstructionQueSubj_label: 'que + сослагательное',
	senseConstructionInfDirecto_label: '+ прямой инфинитив',
	senseConstructionDativoExperimentante_label: 'дативный экспериенцер · me gusta el café',
	senseConstructionObjetoDativo_label: '+ le (дательное дополнение)',
	senseConstructionObjetoAcusativo_label: '+ прямое дополнение',
	senseConstructionSeImpersonal_label: 'безличное se',
	senseMoodInd_label: '+ изъявительное',
	senseMoodSubj_label: '+ сослагательное',

	// ── История занятий (js/session_history.js) ──
	hist_title: "История занятий",
	hist_tooltip: "Все завершённые занятия практики для этой пары языков",
	hist_back_label: "Назад",
	hist_loading: "Загрузка…",
	hist_failed: "Не удалось загрузить историю занятий.",
	hist_empty: "Для этой пары языков пока нет завершённых занятий практики.",
	hist_today: "Сегодня",
	hist_yesterday: "Вчера",
	hist_col_time: "Время",
	hist_col_mastered: "Выучено",
	hist_col_flawless: "Безупречно",
	hist_col_accuracy: "Точность",
	hist_col_shown: "Показов",
	hist_col_wrong: "Ошибок",
	hist_col_spent: "Потрачено",
	hist_col_typical: "Обычно",
	hist_of: "из {0}",
	hist_of_label: "из",
	hist_stopped: "прервано досрочно",
	hist_dir_mix: "Смешанное",
	hist_dir_byEar: "На слух",
	hist_origin_random: "Случайные слова",
	hist_origin_search: "Найденные слова",
	hist_origin_list: "Список: {0}",
	hist_fact_when: "Когда",
	hist_fact_direction: "Направление",
	hist_fact_source: "Источник слов",
	hist_fact_set: "Слов в наборе",
	hist_fact_shown: "Показов",
	hist_fact_correct: "Верно",
	hist_fact_wrong: "Показан ответ",
	hist_fact_replays: "Повторов звука",
	hist_fact_outcome: "Завершение",
	hist_outcome_completed: "Завершено",
	hist_outcome_stopped: "Прервано досрочно",
	hist_flawless_legend: "верно каждый раз — ответ ни разу не раскрыт, ни одной ошибки",
	hist_tip_time: "Когда началось это занятие.",
	hist_tip_mastered: "Слова, с которыми вы закончили, — отложены до конца дня; из числа тех, что занятие собиралось отработать.",
	hist_tip_flawless: "Слова, отвеченные верно при каждом показе: ответ ни разу не раскрывался и ни одного неверного ответа по пути.",
	hist_tip_accuracy: "Верно ÷ показов. Показ заканчивается либо вашим верным ответом, либо раскрытием ответа, так что это доля тех, где вы справились сами.",
	hist_tip_shown: "Сколько раз слова показывались вам для ответа, считая повторы.",
	hist_tip_right: "На сколько из этих показов вы ответили верно — за сколько бы попыток это ни удалось в пределах отведённого времени.",
	hist_tip_wrong: "Сколько показов закончились раскрытием ответа: время вышло или вы сами попросили показать.",
	hist_tip_spent: "От первого слова до последнего — всё занятие целиком, включая паузы.",
	hist_tip_typical: "Сколько обычно занимал верный ответ: срединное значение по словам, чтобы одно длинное выражение не искажало картину.",
	hist_tip_direction: "В какую сторону шла отработка: сначала язык вопроса, потом язык ответа.",
	hist_tip_when: "День и время, когда проходило это занятие, от начала до конца.",
	hist_tip_source: "Откуда взяты слова.",
	hist_tip_set: "Сколько слов было добавлено в набор для этого занятия.",
	hist_tip_replays: "Сколько раз вы переслушивали звучание слова перед ответом. Это запрошенная помощь, а не ошибка.",
	hist_tip_outcome: "Дошло ли занятие до конца или было прервано раньше.",
	hist_tip_word: "Слово, о котором эта строка. Нажмите на строку, чтобы увидеть всю историю его изучения.",
	hist_tip_meaning: "В каком значении слово отрабатывалось на этом занятии — значения, которые действительно спрашивали карточки.",
	hist_tip_wshown: "Сколько раз это слово показывалось вам для ответа.",
	hist_tip_wright: "На сколько из этих показов вы ответили верно — за сколько бы попыток это ни удалось в пределах отведённого времени.",
	hist_tip_wwrong: "Сколько показов закончились раскрытием ответа — время вышло или вы сами попросили показать.",
	hist_tip_wtypical: "Ваше среднее время до верного ответа на этом слове. Показы, на которые вы так и не ответили, не учитываются.",
	hist_tip_firstTry: "Верно с самого первого показа, без единого неверного ответа на нём, — слово, которое вы уже знали. Что было на повторах, на это не влияет.",
	hist_tip_wflawless: "Верно при каждом показе, ответ ни разу не раскрывался и ни одного неверного ответа. Строже, чем чистая первая попытка.",
	hist_firstTry_legend: "верно с первого показа — ни одной ошибки",
	hist_words_none: "Для этого занятия слов не записано.",
	hist_words_masteredHead: "Выучено ({0})",
	hist_words_alsoHead: "Также отработано ({0})",
	hist_words_noMatch: "Под этот фильтр не подходит ни одно слово.",
	hist_wcol_word: "Слово",
	hist_wcol_meaning: "Значение",
	hist_wcol_firstTry: "1-я попытка",
	hist_wcol_replays: "Повторы",
	hist_wcol_right: "Верно",
	hist_wcol_growth: "Рост",
	hist_wcol_next: "Срок",
	hist_wcol_verdict: "Вердикт",
	hist_tip_growth: "Ваше растение для этого слова до и после занятия. Стрелка означает, что оно выросло на ступень; одно бледное растение — что оно осталось на прежней ступени, и это обычный исход для слова, которое полили раньше срока.",
	hist_tip_grew: "На этом занятии растение выросло на ступень.",
	hist_tip_next: "На сколько дней приложение отложило это слово после занятия — интервал, который оно готово подождать, прежде чем спросить снова. Чем дольше, тем крепче держится память.",
	hist_tip_next_drawn: "На этом занятии слову назначена новая дата: {0}.",
	hist_tip_next_held: "Дата не пересматривалась: полив раньше срока или повтор в тот же день оставляют прежний срок в силе. Срок остаётся прежним — {0}.",
	hist_tip_verdict: "Как модель памяти оценила это слово здесь, её собственными словами. Оценка может расходиться с ощущением от отработки: слово, за которое пришлось побороться, всё равно может считаться вспомненным, а слово, названное верно, — попасть в записи как медленное.",
	hist_days_short: "{0} дн.",
	hist_v_cold: "вспомнено сразу",
	hist_v_slow: "знакомо, медленно",
	hist_v_article: "знакомо, артикль",
	hist_v_warmUp: "разминка",
	hist_v_relearned: "переучено",
	hist_v_early: "раньше срока",
	hist_v_sameDay: "в тот же день",
	// …и что каждый из них значит. Это собственный словарь приложения — больше нигде не
	// объясняют, что такое «вспомнилось сразу», — поэтому подсказка объясняет вердикт, а не
	// пересказывает его. Правила за ними — список классов SrsFinishService.
	hist_vtip_cold: "Вы выдали слово сразу, с первой попытки, без всякой помощи, и приложение не нашло в ответе ничего медленного. Самый чистый вид припоминания — именно он двигает растение на следующую ступень.",
	hist_vtip_slow: "Вы справились сами, без подсказок, но вышли за время, которое приложение отводит на это слово, — лимит считается по вашей скорости набора, а не задан жёстко. Это засчитывается как знание, в том числе с почти верным написанием: память есть, просто пока не быстрая.",
	hist_vtip_article: "Само слово вернулось, а артикль (der / die / das) — нет. Это засчитывается как знание слова: род ещё предстоит выучить, и приложение продолжит спрашивать и то, и другое.",
	hist_vtip_warmUp: "Слово вернулось, но не чисто: почти верное написание, которое приложение пропустило, неверный ответ, который вы тут же исправили, или ответ настолько медленный, что он выглядит скорее восстановленным, чем вспомненным. Возможно, по ходу отработки ответ вам всё же показывали — но эта строка о том, что вернулось, а не о том, что делала отработка. До чистого припоминания это не дотягивает, но промахом не считается.",
	hist_vtip_relearned: "Слово пришлось восстанавливать, а не вспоминать: в этот раз оно не всплыло само, поэтому упражнение показало его снова и попросило воспроизвести ещё раз. Ничего не потеряно, растение не уменьшается — слово просто вернётся раньше, а дальше вы продолжите с того места, где были.",
	hist_vtip_early: "Вы отработали это слово до даты полива и не ошиблись. Практика раньше срока засчитывается меньше, чем практика вовремя: растение всё же может подняться на ступень, если память достаточно окрепла, просто для этого нужно больше.",
	hist_vtip_sameDay: "Это слово встретилось снова примерно в течение шести часов после предыдущего засчитанного раза — слишком рано, чтобы что-то доказать, поэтому ничего не измерялось и ничего не выросло. Память растёт в промежутках между занятиями, а не внутри одного.",

	// ── Статистика слов (плитка «слов освоено») + история одного слова ────────────────────
	hist_ws_title: "Статистика слов",
	hist_ws_tooltip: "Все слова, которые вы отрабатывали в этой паре: итоговые числа, тренды и история каждого слова",
	hist_ws_empty: "Для этой пары пока нет отработанных слов.",
	hist_ws_count: "{0} слов · {1} выучено",
	hist_ws_col_sessions: "Занятия",
	hist_ws_col_trend: "Тренд",
	hist_ws_col_mastered: "Выучено",
	hist_ws_mastered_legend: "выучено хотя бы на одном занятии — из них складывается число на плитке",
	hist_ws_tip_word: "Слово, о котором эта строка. Нажмите на строку, чтобы открыть его полную историю.",
	hist_ws_tip_sessions: "Сколько завершённых занятий включали это слово.",
	hist_ws_tip_shown: "Сколько раз это слово показывалось вам для ответа — за все занятия.",
	hist_ws_tip_right: "Показы, на которые вы ответили правильно, за все занятия.",
	hist_ws_tip_wrong: "Показы, закончившиеся раскрытием ответа: истекло время или вы попросили показать.",
	hist_ws_tip_accuracy: "Правильных ÷ показов за всю историю слова.",
	hist_ws_tip_typical: "Ваше среднее время до правильного ответа на это слово за все занятия.",
	hist_ws_tip_trend: "Скорость ответа: поздние занятия против ранних. ▼ — быстрее. Нужно несколько занятий с таймером, прежде чем появится результат.",
	hist_ws_tip_mastered: "Доведено до конца хотя бы на одном занятии — правильных ответов набрано нужное число. Из этих строк складывается плитка «слов выучено».",
	hist_ws_chart_speed: "Типичное время ответа по занятиям",
	hist_ws_tip_chart_speed: "Каждая точка — одно завершённое занятие: его типичное (медианное по словам) время до правильного ответа. Линия вниз — вы отвечаете быстрее.",
	hist_ws_chart_mastered: "Динамика выученных слов",
	hist_ws_tip_chart_mastered: "Выученные слова, суммарно от занятия к занятию.",
	hist_chart_few: "Здесь пока слишком мало практики, чтобы построить график.",
	hist_wh_tip_dictionary: "Открыть полную словарную статью этого слова.",
	hist_wh_none: "Это слово ещё не отрабатывалось.",
	hist_wh_col_when: "Когда",
	hist_wh_tip_when: "Занятие, на котором отрабатывалось это слово, — день и время начала. Нажмите на строку, чтобы открыть это занятие.",
	hist_wh_firstSeen: "Первая отработка",
	hist_wh_tip_firstSeen: "Первое занятие, на котором встретилось это слово.",
	hist_wh_lastSeen: "Последняя отработка",
	hist_wh_tip_lastSeen: "Последнее занятие, на котором встретилось это слово.",
	hist_wh_stage: "Ступень роста",
	hist_wh_tip_stage: "Растение этого слова в вашем саду: с каждым успешным повторением по расписанию оно вырастает на ступень, до 7-й.",
	hist_wh_due: "Следующий полив",
	hist_wh_tip_due: "Когда приложение планирует снова проверить это слово. Чем крепче память, тем больше промежутки между повторениями.",
	hist_wh_overdue: "просрочено",
	hist_wh_lapses: "Забывания",
	hist_wh_tip_lapses: "Повторения, на которых слово успело забыться и его пришлось учить заново.",
	hist_wh_article: "Артикль",
	hist_wh_articleNone: "не введён",
	hist_wh_tip_article: "Случаи, когда слово вы вспомнили, но взяли не тот артикль. Это засчитывается как знание слова — практики требует род, и его отрабатывает упражнение на артикли.",
	hist_wh_chart_speed: "Скорость ответа",
	hist_wh_tip_chart_speed: "Линия — ваше типичное время до правильного ответа за занятие. Мелкие точки — отдельные показы. ✗ вверху — показ, на котором ответ пришлось раскрыть.",
	hist_wh_chart_gaps: "Дни между отработками",
	hist_wh_tip_chart_gaps: "Промежуток перед каждой отработкой этого слова. Растущие промежутки — признак крепнущей памяти: приложение решается ждать дольше, а вы всё равно помните. Столбик с контуром — следующее запланированное повторение. Пунктир — то, что приложение обещало на каждом занятии: выше своего столбика — значит, вы вернулись раньше, чем было нужно.",
	hist_wh_scheduled: "запланировано",
	hist_wh_chart_stage: "Рост растения",
	hist_wh_tip_chart_stage: "Ступень в саду после каждого зачтённого повторения. Зелёный — повторение пройдено. Красный — слово забылось, и растение отброшено назад.",
	hist_wh_chart_acc: "Точность по занятиям",
	hist_wh_tip_chart_acc: "Правильных ÷ показов на каждом занятии, где отрабатывалось это слово.",
	hist_wh_revealed: "раскрыто",
	hist_wh_pass: "пройдено",
	hist_wh_fail: "забыто",
	// ── The accuracy root (the "accuracy" tile) + the time root (the "studied" tile) ─────────
	hist_acc_title: "Точность",
	hist_acc_tooltip: "Как складывается ваша точность и как она меняется — от занятия к занятию, и какие слова тянут её вниз",
	hist_acc_firstTry_lbl: "узнано сразу",
	hist_acc_tip_accuracy: "Верно ÷ показов по всему, что вы отрабатывали в этой языковой паре, — то же число, что и на плитке панели.",
	hist_acc_tip_firstTry: "Слова, на которые вы ответили верно при самом первом показе, из всех слов, которые встретились вам на занятиях. Разница с точностью — это и есть вклад самой отработки.",
	hist_acc_tip_chart_bySession: "Верно ÷ показов для каждого завершённого занятия, от старых к новым.",
	hist_acc_chart_firstTry: "Узнано сразу по занятиям",
	hist_acc_tip_chart_firstTry: "Доля слов каждого занятия, на которые вы ответили верно при самом первом показе, — узнавание до того, как начинает помогать отработка.",
	hist_acc_hard_head: "Самые трудные слова ({0})",
	hist_acc_hard_sub: "самая низкая точность среди слов, показанных не менее {0} раз — нажмите на слово, чтобы увидеть его историю",
	hist_acc_hard_none: "Ничего не выделяется — среди слов с достаточным числом показов нет низкой точности.",
	hist_time_title: "Время занятий",
	hist_time_tooltip: "Куда ушло время занятий — по дням, в сумме, и что даёт час практики",
	hist_time_typical_lbl: "обычное занятие",
	hist_time_days_lbl: "активных дней",
	hist_time_tip_total: "Длительность всех завершённых занятий, сложенная вместе. Паузы внутри занятия считаются, время между занятиями — нет.",
	hist_time_tip_sessions: "Завершённые занятия практики для этой пары — то же число, что и на плитке панели.",
	hist_time_tip_typical: "Срединная длительность занятия: половина занятий была короче, половина — длиннее, так что один марафонский вечер её не сдвинет.",
	hist_time_tip_days: "Дни, в которые есть хотя бы одно завершённое занятие. День длится до 3:00 утра, поэтому занятие после полуночи относится к своему вечеру.",
	hist_time_fact_longest: "Самое долгое занятие",
	hist_time_tip_longest: "Самое долгое занятие за один присест и день, когда оно случилось.",
	hist_time_fact_perDay: "В среднем за активный день",
	hist_time_tip_perDay: "Общее время занятий ÷ дни, в которые вы действительно практиковались.",
	hist_time_fact_perWord: "На выученное слово",
	hist_time_tip_perWord: "Общее время занятий ÷ число выученных слов — во столько обходится одно закреплённое слово. Со временем эта цифра должна падать — это и есть успех.",
	hist_time_chart_byDay: "Время практики по дням",
	hist_time_tip_chart_byDay: "Минуты завершённой практики в каждый день занятий — разрывы соответствуют дням без практики.",
	hist_time_chart_total: "Накопленные часы",
	hist_time_tip_chart_total: "Время занятий, складывающееся занятие за занятием. Регулярная привычка выглядит как ровный наклон.",

	// ── Отзывы: диалог 💬 (js/feedback.js) ──
	feedback_menu: "Отправить отзыв",
	feedback_title: "Отправить отзыв",
	feedback_type_problem: "Проблема",
	feedback_type_dislike: "Не нравится",
	feedback_type_like: "Нравится",
	feedback_type_idea: "Предложение",
	feedback_type_question: "Вопрос",
	feedback_ph_start: "Выберите тип выше и напишите сообщение",
	feedback_ph_problem: "Что пошло не так?",
	feedback_ph_dislike: "Что вам не нравится?",
	feedback_ph_like: "Что вам нравится?",
	feedback_ph_idea: "Что можно сделать лучше?",
	feedback_ph_question: "Что вы хотели бы узнать?",
	feedback_email_label: "Email для ответа (необязательно)",
	feedback_send: "Отправить",
	feedback_cancel: "Отмена",
	feedback_thanks: "Спасибо! Мы читаем каждое сообщение.",

	// ── Аудит решений по словам сессии — только для владельца (session-word-audit.md) ──
	audit_title: "Аудит слов",
	audit_none: "Для этого занятия аудит не записан.",
	audit_empty: "В этом занятии нет слов с аудитом.",
	audit_finish_tooltip: "Только для владельца: полное обоснование решений по каждому слову занятия",
	audit_history_chip: "аудит",
	audit_y_pass: "верно",
	audit_y_fail: "неверно",
	audit_y_void: "недейств.",
	audit_col_seq: "№",
	audit_col_outcome: "Итог",
	audit_col_tier: "Уровень",
	audit_col_latency: "Задержка",
	audit_col_shownTs: "Показано",
	audit_outcome_PASS: "верно",
	audit_outcome_FAIL: "неверно",
	audit_outcome_TIMEOUT: "таймаут",
	audit_outcome_MEET: "знакомство",
	audit_outcome_REVEAL: "раскрытие",
	audit_acol_attempt: "#",
	audit_acol_submitted: "Ввод",
	audit_acol_correct: "Верно",
	audit_acol_similarity: "Схож.",
	audit_acol_errorClass: "Ошибка",
	audit_acol_firstKeyMs: "1-я клав.",
	audit_acol_completionMs: "Завершение",
	audit_acol_allottedMs: "Отведено",
	audit_acol_keystrokes: "Клав.",
	audit_acol_backspaces: "Стир.",
	audit_yes: "Да",
	audit_no: "Нет",
	audit_censored: "цензурировано",
	audit_group_label: "Метка",
	audit_group_m5: "M5",
	audit_group_garden: "Сад",
	audit_f_y: "y",
	audit_f_labelFlags: "Флаги",
	audit_f_nPres: "n показов",
	audit_f_nMin: "n мин",
	audit_f_criterionMet: "Критерий выполнен",
	audit_f_g: "g",
	audit_f_gFinal: "g итог",
	audit_f_epsilon: "Эпсилон",
	audit_f_lStarMs: "L*",
	audit_f_sBefore: "S до",
	audit_f_sAfter: "S после",
	audit_f_dAfter: "D после",
	audit_f_rHat: "R̂",
	audit_f_rStar: "R*",
	audit_f_intervalDays: "Δдней",
	audit_f_floored: "Ограничено",
	audit_f_dueTs: "Срок",
	audit_f_algoVersion: "Версия алг.",
	audit_f_decisionType: "Тип решения",
	audit_f_stageBefore: "Ступень до",
	audit_f_stageAfter: "Ступень после",
	audit_f_result: "Результат",
	audit_f_wasDue: "Был срок",
	audit_f_promoted: "Повышено",
	audit_f_planted: "Посажено",
	audit_f_grew: "Выросло",
	audit_f_lapses: "Провалы",
	// The P4 shadow-verdict strip (verdict v2 in shadow, garden-srs-implementation-plan.md P4) —
	// a compact addendum per word, sourced from the shadow service's own computed data.
	audit_group_verdict: "Вердикт",
	audit_group_flower: "Цветок",
	audit_decision_head: "Решение",
	audit_f_notch: "Насечка",
	audit_f_band: "полоса ≥",
	audit_f_showingsPlanned: "запланировано",
	audit_f_bucket: "Корзина",
	audit_f_nextMarkDays: "След. отметка (д)",
	audit_f_otherEngine: "Другой движок сказал",
	audit_f_dueModel: "Срок (модель)",
	audit_f_nextShown: "След. показ",
	audit_more_showings: "ещё показы после фиксации — только как свидетельство",
	audit_more_details: "Всё остальное (полные показы, все насечки, дословные блоки)",
	audit_lcol_showings: "Показы",
	audit_lcol_peeks: "Подглядывания",
	audit_lcol_time: "Время",
	audit_lcol_close: "Близость",
	audit_lcol_rstar: "r*",
	audit_lcol_flower: "Цветок",
	audit_lcol_why: "Почему",
	audit_words_count: "слов: {0}",
	audit_grid_mixed: " · разные насечки",
	audit_gate_perfect: "идеально",
	audit_gate_off_peeks: "Лимит подглядываний есть только у семейства A (насечки 1–3).",
	audit_gate_off_time: "Только наблюдение — состав никогда не считывает шкалу времени. Факт = вес насечки × задержка/отведённое ({0}) решающего показа.",
	audit_gate_off_rstar: "M5 запланирован по r* {0}; цель для отдельной насечки неактивна до переключения P7.",
	audit_gate_off_close_c: "Семейство C игнорирует полосу: условие — идеальный показ (≥ {0} не читается).",
	audit_why_close: "ниже полосы на показе {0}",
	audit_why_peek: "подглядывания сверх лимита на показе {0}",
	audit_why_perfect: "не идеально на показе {0}",
	audit_why_void: "нигде не зафиксировано — показано {0} из {1}",
	audit_why_pass: "пройдено на показе {0}",
	audit_why_unknown: "зафиксировано на показе {0} — семейство не записано",
	audit_v2_title: "v2 (теневой)",
	audit_v2_sealedAt: "Зафиксировано на показе",
	audit_v2_evid_col_seq: "#",
	audit_v2_evid_col_perfect: "Идеально",
	audit_v2_evid_col_sim: "Сходство свид.",
	audit_v2_evid_col_veto: "Вето",
	audit_v2_guardFlags: "Флаги защиты",
	audit_v2_gradedCut: "Порог оценки",
	// ── Ползунок строгости, живая подпись (strictness_captions.js): по одной фразе на деление —
	// что нужно сделать, чтобы слово было засчитано, и сколько раз (сетка §3 спецификации:
	// 1–3 — по памяти после не более 2/1/1 просмотров ответа; 4–6 — почти верная попытка до показа
	// ответа, в 1/2/2 показах; 7–10 — точный ответ до конца отсчёта, в 2/3/3/3 показах). Степень
	// точности — честный «диммер» на делениях 1–6 (совсем приблизительно → приблизительно →
	// примерно верно → почти верно → почти точно); 8–10 живут по одному правилу и отличаются лишь
	// акцентом. Переписано 2026-09-01 (владелец: «comes back» непонятно) словами самой тренировки:
	// «по памяти», «показ ответа», «отсчёт». Десять различных подписей, каждая — не длиннее двух
	// строк панели настроек (temp/ui-smoke/strictness-caption-width-probe.mjs).
	strictness_captionN1: "Можно посмотреть ответ до двух раз, затем набрать слово по памяти — совсем приблизительно",
	strictness_captionN2: "Можно посмотреть ответ один раз, затем набрать слово по памяти — совсем приблизительно",
	strictness_captionN3: "Можно посмотреть ответ один раз, затем набрать слово по памяти — приблизительно",
	strictness_captionN4: "Набрать слово примерно верно до показа ответа, один раз",
	strictness_captionN5: "Набрать слово почти верно до показа ответа, два раза",
	strictness_captionN6: "Набрать слово почти точно до показа ответа, два раза",
	strictness_captionN7: "Набрать слово точно до конца отсчёта, два раза",
	strictness_captionN8: "Набрать слово точно до конца отсчёта, три раза",
	strictness_captionN9: "Набрать слово точно до конца отсчёта, три раза подряд",
	strictness_captionN10: "Набрать слово точно до конца отсчёта, каждый раз — и никаких подсказок",
	// ── Части речи (pos_label.js) — сокращение + подсказка на каждое понятие. Бюджет — 5
	// символов (тот же, что и для EN/FR); конвенция без точки на конце выдерживается и здесь.
	// "союз" и "фраза" уже укладываются целиком, поэтому их подсказка не показывается (wire()
	// сравнивает сокращение с подсказкой и молчит, если они совпадают).
	posNoun_label: "сущ.",
	posNoun_tooltip: "существительное",
	posVerb_label: "гл.",
	posVerb_tooltip: "глагол",
	posAdjective_label: "прил.",
	posAdjective_tooltip: "прилагательное",
	posAdverb_label: "нар.",
	posAdverb_tooltip: "наречие",
	posPhrase_label: "выраж.",
	posPhrase_tooltip: "выражение",
	// Спряжённая форма глагола, сохранённая как отдельное слово ("ich stehe auf").
	posPhraseVerbConj_label: "форма",
	posPhraseVerbConj_tooltip: "спрягаемая форма глагола",
	// Карточка основных форм глагола ("go, went, gone"), тоже отдельное слово.
	posVerbForms_label: "формы",
	posVerbForms_tooltip: "основные формы глагола",
	posPreposition_label: "предл.",
	posPreposition_tooltip: "предлог",
	posPronoun_label: "мест.",
	posPronoun_tooltip: "местоимение",
	posConjunction_label: "союз",
	posConjunction_tooltip: "союз",
	posInterjection_label: "межд.",
	posInterjection_tooltip: "междометие",
	posNumeral_label: "числ.",
	posNumeral_tooltip: "числительное",
	posArticle_label: "арт.",
	posArticle_tooltip: "артикль",
	posDeterminer_label: "дет.",
	posDeterminer_tooltip: "детерминатив",
	posAbbreviation_label: "сокр.",
	posAbbreviation_tooltip: "сокращение",
	posParticle_label: "част.",
	posParticle_tooltip: "частица",
	posPrefix_label: "прист.",
	posPrefix_tooltip: "приставка",
	// ── Виды словоформ (56 193 тонких строк word_form: 42 095 DE, 14 098 EN). Это не части речи —
	// строка формы хранит свой ВИД в sense.pos, по образцу phrase_verb_conj. Тот же бюджет в 5
	// символов и та же конвенция без точки на конце.
	// ⚠️ Подсказки согласованы с WORD_FORM_KINDS_RU (main.js) — той же терминологией подписана
	// поясняющая строка в статье («прошедшее время от play»). Правьте вместе.
	// Исключения, намеренные: `other` здесь «прочее», а не «форма слова» (PosLabel видит pos='other'
	// и у обычных значений, не только у форм), а `contraction` — «стяжённая форма», чтобы не
	// совпадать с подсказкой сокращения (posAbbreviation_tooltip).
	posPlural_label: "мн",
	posPlural_tooltip: "мн. число",
	posGenitiveSg_label: "род",
	posGenitiveSg_tooltip: "родительный падеж ед. числа",
	posDeclined_label: "скл",
	posDeclined_tooltip: "склонённая форма",
	posPast_label: "прош",
	posPast_tooltip: "прошедшее время",
	posPreterite_label: "прет",
	posPreterite_tooltip: "претерит (простое прошедшее)",
	posPastParticiple_label: "прич",
	posPastParticiple_tooltip: "причастие прош. времени",
	posPresent1Sg_label: "1ед",
	posPresent1Sg_tooltip: "настоящее время, 1-е лицо ед. числа",
	posPresent2Sg_label: "2ед",
	posPresent2Sg_tooltip: "настоящее время, 2-е лицо ед. числа",
	posPresent3Sg_label: "3ед",
	posPresent3Sg_tooltip: "настоящее время, 3-е лицо ед. числа",
	posImperative_label: "импер",
	posImperative_tooltip: "императив",
	posSubjunctiveII_label: "конъ2",
	posSubjunctiveII_tooltip: "конъюнктив II",
	posSeparableParticle_label: "отд",
	// ⛔ NOT 'отделяемая приставка': строка описывает спрягаемую форму глагола ('stehe' при лемме
	// 'aufstehen'), а не саму приставку ('auf'). Twinned with WORD_FORM_KINDS_RU.separable_particle.
	posSeparableParticle_tooltip: "отделяемая форма",
	posComparative_label: "комп",
	posComparative_tooltip: "компаратив",
	posSuperlative_label: "супер",
	posSuperlative_tooltip: "суперлатив",
	posIngForm_label: "-ing",
	posIngForm_tooltip: "форма на -ing",
	posContraction_label: "стяж",
	posContraction_tooltip: "стяжённая форма",
	posSuppletive_label: "суппл",
	posSuppletive_tooltip: "супплетивная форма",
	posProperNoun_label: "собст",
	posProperNoun_tooltip: "имя собственное",
	posSpellingVariant_label: "вар",
	posSpellingVariant_tooltip: "вариант написания",
	posFusion_label: "слит",
	posFusion_tooltip: "слитная форма",
	posOther_label: "др",
	posOther_tooltip: "другое"
};
